import { RestApi } from 'src/app/shared/RestApi/restApi';
import {Component, OnInit, ViewChild} from '@angular/core';
import { EtlService } from '../vault-data-migration-etl/etl.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { constants } from 'src/app/shared/common/contants';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { FiledownloadComponent } from 'src/app/shared/common/filedownload.component';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { ActionCheckBox } from 'src/app/shared/common/ActionCheckBox';
import { environment } from 'src/environments/environment';
import { ResumeLoadButton } from 'src/app/shared/common/resumeLoadButton';
import { FileUploadButton } from 'src/app/shared/common/fileUploadbutton';
import { isEmpty, sample, Subscription } from 'rxjs';
import { EtllibraryobjectsComponent } from '../etllibraryobjects/etllibraryobjects.component';
import { UpdatecasedataComponent } from '../updatecasedata/updatecasedata.component';
import { EtlfiltersComponent } from '../etlfilters/etlfilters.component';
import { Migrationtracelogs } from 'src/app/shared/common/Migrationtracelogs';
import { ValidationReportDownload } from 'src/app/shared/common/ValidationReportDownload';
import { SummaryReportDownload } from 'src/app/shared/common/SummaryReportDownload';
import { GenerateReport } from 'src/app/shared/common/GenerateReport';
import { GeneratedSummaryReport } from 'src/app/shared/common/generatedsummaryreport';
import { SpliteAndGenerateQtlReportPopupComponent} from './splite-and-generate-qtl-report/splite-and-generate-qtl-report-popup.component';
import {GenerateButton} from '../../shared/common/generate-button.component';
import {LoadToVault} from "../../shared/common/LoadToVault";
import {DocAttachmentFilePath} from "../../shared/common/doc-attachment-file-path.component";
import {DownloadMappingFile} from "../../shared/common/downloadmappingfile";

import {MatMenuTrigger} from "@angular/material/menu";
import {LinkToCasesButton} from "../../shared/common/linkToCasesButton";
import {AddSetsForMigrationPopupComponent} from "./add-sets-for-migration-popup/add-sets-for-migration-popup.component";
import {ReInitiate} from "../../shared/common/reInitiate";
import {ReInitiatePopupComponent} from "./re-initiate-popup/re-initiate-popup.component";
import {ReMigrationButton} from "../../shared/common/reMigrationBttn";
import { DeleteCaseButton } from 'src/app/shared/common/deleteCaseButton';
import {GeneratedSplitReport} from "../../shared/common/generatedsplitreport";
import {VaultGlobalObjectsComponent} from "./vault-global-objects/vault-global-objects.component";
import {PopupButton} from "../../shared/common/popupbutton";
import { ResumeExtractionButton } from 'src/app/shared/common/ResumeExtractionButton';
import { CommonTs } from 'src/app/shared/common/CommonTs';
import { error } from 'console';
import { EtlMigrationPopupComponent } from '../etl-migration-popup/etl-migration-popup.component';
import { ok } from 'assert';
import { IncrementalDataLoadSchedulePopupComponent } from '../baseline-data-load/incremental-data-load-schedule-popup/incremental-data-load-schedule-popup.component';
import { HeadersPopupDialogComponent } from './headers-popup-dialog/headers-popup-dialog.component';
import { RunningJarPopupComponent } from './running-jar-popup/running-jar-popup.component';
import { ValidateconfigurationPopupComponent } from './validateconfiguration-popup/validateconfiguration-popup.component';
import { DeleteObjctsPopupComponent } from './delete-objcts-popup/delete-objcts-popup.component';
import { UserRoutingModule } from 'src/app/user/user-routing/user-routing.module';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { RetrieveScreenAccess } from 'src/app/shared/models/userrole'




export interface ETLProcess {
  name: string;
  value: string;
}

@Component({
    selector: 'app-etl',
    templateUrl: './etl.component.html',
    styleUrls: ['./etl.component.scss'],
    standalone: false
})
export class ETLComponent implements OnInit {
  
  temperveryvalue:any;
  gridvalues:any;
  subgridvalues:any;
  resultantvalue:any;
  data:any;
  data1:any;
  gridAPI;
  gridLoaderAPI;
  gridmgrnAPI;
  loaderAPI:any;
  gridData:any;
  gridattachmentData:any;
  gridLoadData:any;
  gridmgrnData:any;
  extractionData:any=[];
  globalExtractionData:any=[];
  transformData:any=[];
  tempmgrndata:any=[];
  tempAttachmentgridData:any=[];
  loaderData:any=[];
  loadsetId:any=[];
  extractionTrace=false;
  migrationTrace= true;
  loaderTrace = false;
  transformTrace=false;
  globaltrace=false;
  RunlastPage;
  RuncurrentPage;
  RunnextPage;
  RunnextPagePlusOne;
  RuntotalPages;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  loadtotalPages;
  loadnextPagePlusOne;
  loadnextPage;
  loadcurrentPage;
  loadlastPage;
  gridColumnAPI;
  columnDefs;
  columnHeaderForGlobalTab;
  columnDefsFormigration;
  rowData;
  rowClassRules;
  defaultColDef;
  rowSelection;
  rowSelectionForTablesFields;
  rowMultiSelectWithClick;
  paginationPageSize;
  paginationNumberFormatter;
  RunpageSize;
  pageSize;
  loadpageSize
  components: any;
  overlayNoRowsTemplate;
  buttonName;
  getdata: any;
  backgroundColorScreen: any;
  backgroundColorButton: any;
  buttonColor = "";
  tempextractparams:any;
  tempglobalextractparams:any;
  temprunHistory:any;
  statevaluechange={"fileName":"","fileData":""}
  // Added variable for uploadloader function
  uploadloaderstatechange={"fileName":"","fileData":""}
  updatedsourceFile= {"uploadfileName": "", "migrationId": "", "setId": ""}
  // Added variables for migration set and set size fields by kalpesh 11-08-2022
  defferedData = {"defferedSets": "", "defferedObjects": "", "migrationSets": "", "setSize": ""}
  s3Path= "";
  imagephoto;
  imagephotoshow: any = false;
  value;
  startmigration;
  eachsetId:any=[];
  FormValid: UntypedFormGroup;
  FormValidS3: UntypedFormGroup;
  FormValidStartRun: UntypedFormGroup;
  validation_messages;
  eachetlName = 'Extraction';
  MappingFile;
  migrationDataLoadLogObject: any = [];
  mgrstatus: any;
  mgrstartdt : any;
  mgrid: any;
  loadingProcess="CaseData";
  uploadisDisable = true;
  loadingActivity:any;
  columnDefsExtract;
  columnDefsLoader;
  columnDefsLoadAttachment;
  transformApi:any;
  transformsetid="";
  tempextdata:any;
  temptrnsdata:any;
  tempdata:any;
  temploaddata:any
  migrationData;
  migrationParentId;
  migrationTraceId;
  migrationSelectedId;
  parentSetId;
  setId;
  instructionGrid;
  activityLoad;
  setvalidationdata:any;
  validationreport=false;
  vaultvalidationAPI;
  gridAPIValidation;
  gridDataValidation:any;
  vaultValidationData:any=[];
  temploaddataValidation:any=[];
  updateSubscription: Subscription;
  migrationType= "";
  text = "Pause";
  migrationTypeButton="Attachments";
  selectedGrid: string = 'new';
  gridColumnApi


  flag = false;
  dFlage = true
  globalCheckbox
  ftpuploadCheckbox
  attachextractCheckbox
  validationCheckbox
  loadCheckbox
  transformationCheckbox
  extractionCheckbox
  jsuiteValue: any;
  jsuitepropertyValue: any;
  dnsId:any;
  setSelect:boolean = false;
  selectValidSet:boolean = false;
  defferedSetData:any;
  defferedObjectData:any = [];
  alldefferedObjects:any = [];
  columnDefsExtractionAndTransformation;
  // we create an object that contains coordinates
  menuTopLeftPosition =  {x: 0, y: 0}
  isRowSelectable: any;
  gridOptions:any;
  status:any;
  migrationId;
  preLoadTransformationCheckbox
  //variables for third grid in the migration screen
  extractionInstruction;
  transformInstruction;
  loadInstruction;
  loadAttachmentInstruction;
  extractionInstructionAPI;
  transfromationInstructionAPI;
  extractionInstrictionTrace;
  loadInstructionTrace;
  attachmentLoadInstructionTrace
  extractionInstructionData: any[];

  isDisabled= false;
  // Radio button Disable variables initially set to false
  isDisabledForObjectGrid=false;
  docAttachedClickedEvent=false;
  // check for radio button default value checked to extraction
  objectRadioValue="extractionObjects";
  isDisableTransformbtn=false
  isDisableLoadbtn=false;

  migrationTraceRadioSelection;
  showScheduler=false;
  private responserequest: any;
  buttonIdList: number[] = [];
  s3DataSize
  restrictDownloadFlage = true
  restrictDownloadSummaryFlag=true


 
  
/**
 * These are the parameters for Object grid (3rd grid ). By using these parameters only we will 
 * handle the third grid.
 * For every activity we are using two types of API
 * 1) one is for while clicking on the set data we are rendering the current activity object in third grid. Since we are not aware of traceid for three activities 
 *  we are handling through migrationid,setid and dnsid
 * 2) while refreshing the objects we are retrieving the data by migrationtraceid because refresh is specific to teh every activity.
 * 
 */
  migrationTraceForObjectGrid;
  currentActivityInObjectGrid;
  currentActivityInMigrationGrid
  currentSetInMigrationGrid
  currentMigrationIdInMigrationGrid
  currentMigrationTraceIdInMigrationGrid
  isAddSets=false;
  columDifsForMigrationTemp = [
    {
      headerName: "Migration Id",
      headerTooltip: "Migration Id",
      tooltipValueGetter: params => "Migration Id : " + params.value,
      field: "migrationId",
      filter: "agTextColumnFilter",
      width: 120
    },
    {
      headerName: 'Source',
      headerTooltip: 'Source',
      tooltipValueGetter: (params) => 'Source : ' + params.value,
      field: 'sourcedns',
      filter: 'agTextColumnFilter',
      width: 200
    },
    {
      headerName: 'Target',
      headerTooltip: 'Target',
      tooltipValueGetter: (params) => 'Target : ' + params.value,
      field: 'targetdns',
      filter: 'agTextColumnFilter',
      width: 200
    },
    // added column in run history grid for comments
    {
      headerName: 'Description',
      headerTooltip: 'Description',
      tooltipValueGetter: (params) => 'Description : ' + params.value,
      field: 'comment',
      filter: 'agTextColumnFilter',
      width: 200
    },
    {
      headerName: 'Data Extraction Type',
      headerTooltip: 'Data Extraction Type',
      tooltipValueGetter: (params) => 'Data Extraction Type : ' + params.value,
      field: 'dataextractiontype',
      filter: 'agTextColumnFilter',
      width: 200
    },
    // {
    //   headerName: 'Start Date and Time',
    //   headerTooltip: 'Start Date and Time',
    //   tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value,
    //   field: 'startdt',
    //   filter: 'agTextColumnFilter',
    //   width: 180
    // },
    // {
    //   headerName: 'End Date and Time',
    //   headerTooltip: 'End Date and Time',
    //   tooltipValueGetter: (params) => 'End Date and Time : ' + params.value,
    //   field: 'enddt',
    //   filter: 'agTextColumnFilter',
    //   width: 180
    // },
    {
      headerName: 'Status',
      headerTooltip: 'Status',
      tooltipValueGetter: (params) => 'Status : ' + params.value,
      field: 'state',
      filter: 'agTextColumnFilter',
      sort: "desc",
      width: 120
    },
    {
      headerName: 'Executed By',
      headerTooltip: 'Executed By',
      tooltipValueGetter: (params) => 'Executed By : ' + params.value,
      field: 'executedby',
      filter: 'agTextColumnFilter',
      width: 180
    },
    {
      headerName: 'Mapping file Validation State',
      headerTooltip: 'Mapping file Validation State',
      tooltipValueGetter: (params) => 'Mapping file Validation State : ' + params.value,
      field: 'mappingFileValidationState',
      filter: 'agTextColumnFilter',
      width: 120
    },
    
    {
      headerName: 'Generate Summary Report', filter: false, cellRenderer: 'generateBttn',
      headerTooltip: 'Generate Summary Report',
      tooltipValueGetter: (params) => 'Generate Validation Summary Report',
      cellRendererParams: {
        generateReport: this.generateSummaryReport.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 120
    },
    {
      headerName: 'Services Assigned', filter: false, cellRenderer: 'generateBttn',
      headerTooltip: 'Services Assigned',
      tooltipValueGetter: (params) => 'Services Assigned',
      cellRendererParams: {
        generateReport: this.selectService.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 120
    },

    {
      headerName: 'Download Summary Report',
      headerTooltip: 'Download Summary Report',
      tooltipValueGetter: (params) => 'Download Summary Report',
      cellRenderer: 'genratedSummaryReport',
      cellRendererParams: {
        downloadgeneratedSummaryReport: this.downloadgeneratedSummaryReport.bind(this)
        //delete: this.deleteIcon.bind(this),
      },
      width: 200
    },
   {
     headerName: 'Generate Split Report',
     headerTooltip: 'Generate Split Report',
     tooltipValueGetter: (params) => 'Generate Split Report',
      filter: false,cellRenderer: 'generateBttn',
      cellRendererParams: {
        generateReport: this.generateSplitReport.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 120
    },
    {
      headerName: 'Download Split Report',
      headerTooltip: 'Download Split Report',
      tooltipValueGetter: (params) => 'Download Split Report',
      cellRenderer: 'generatedSplitReport',
      cellRendererParams: {
        downloadgeneratedSplitReport: this.downloadgeneratedSplitReport.bind(this)
        //delete: this.deleteIcon.bind(this),
      },
      width: 200
    },
    {
      
      headerName: 'Validate Mapping File', filter: false, cellRenderer: 'generateBttn',
      headerTooltip:'Validate Mapping File',
      tooltipValueGetter: (params) => 'Validate Mapping File',
      cellRendererParams: {
        generateReport: this.validateMappingFile.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 120
    },
    {
      headerName: 'Download Mapping file Validation Report',
      headerTooltip: 'Download Mapping file Validation Report',
      filter: false,
      cellRenderer: 'downloadbuttonRenderer',
      cellRendererParams: {
        docdownload: this.downloadMappingFileValidationReport.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 120
    },
    {
      
      headerName: 'Download Mapping File',
      headerTooltip:'Download Mapping File',
      tooltipValueGetter: (params) => 'Download Mapping File',
      cellRenderer: 'downloadMappingFile',
      cellRendererParams: {
        downloadMappingFile: this.downloadMappingFile.bind(this)
        //delete: this.deleteIcon.bind(this),
      },
      width: 200
    },
    
    {
      headerName: 'Target Global Object(s)',
      headerTooltip: 'Target Global Object(s)',
      filter: false,
      tooltipValueGetter: (params) => 'Target Global Object(s)',
      cellRenderer: 'PopupButtonRenderer',
      cellRendererParams: {
        button: this.vaultGlobalObject.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 120
    },

    // hold the parent migrationid value
    {
      headerName: 'Parent Migration Id',
      headerTooltip: 'Parent Migration Id',
      tooltipValueGetter: (params) => 'Parent MigrationId: ' + params.value,
      field: 'parentmigrationid',
      filter: 'agTextColumnFilter',
      width: 180
    },

    {
      headerName: 'Start Date and Time',
      headerTooltip: 'Start Date and Time',
      tooltipValueGetter: (params) => 'Start Date and Time: ' + params.value,
      field: 'startdt',
      filter: 'agTextColumnFilter',
      width: 180
    },

    {
      headerName: 'End Date and Time',
      headerTooltip: 'End Date and Time',
      tooltipValueGetter: (params) => 'End Date and Time: ' + params.value,
      field: 'enddt',
      filter: 'agTextColumnFilter',
      width: 180
    },
    {
      headerName: 'Validate Configurations', filter: false, cellRenderer: 'generateBttn',
      headerTooltip:'Validate Configurtions',
      tooltipValueGetter: (params) => 'Validate Configurtions',
      cellRendererParams: {
        generateReport: this.validateConfigurations.bind(this),
        
      }, width: 120
    },
    {
      headerName: 'Mapping File Version',
      headerTooltip: 'Mapping File Version',
      tooltipValueGetter: (params) => 'Mapping File Version: ' + params.value,
      field: 'mappingfileversion',
      filter: 'agTextColumnFilter',
      width: 180
      },
      /*
 * @modifiedBy Sujeet Sharma
 * @date 19/09/2025
 * @note Added "Remarks" column in Run History grid.
 *       - Column supports filtering and tooltips.
 *       - If removed by user, it will still be available in the column selector pop-up
 *         for re-adding when needed.
 */

     {
            headerName: 'Remarks',
            headerTooltip: 'Remarks',
            tooltipValueGetter: (params) => 'Remarks : ' + params.value,
            field: 'remarks',
            filter: 'agTextColumnFilter',
            width: 120
          }
    
  ];
  
  // reference to the MatMenuTrigger in the DOM
  @ViewChild(MatMenuTrigger, {static: true}) matMenuTrigger: MatMenuTrigger;
  extractionType: string;
  loadActionForSelecetdSet: any;
  selectedSourceName: any;
  selectedSource: any;
  selectedTarget: any;
  SourceId: any;
  targetId: any;
  migrationSelectedType: any;
  sourceSystemTypeName: any;
  selectedRowDataFromGrid: any;
  mappingfileversion: any;
  migrationid: any;
  spinnerStopping: boolean;
  selectedObjectGroups: any;

  

  constructor(private commonTs:CommonTs, private service:EtlService, private localStorageSettings: LocalStorageSettingsService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private constants: constants,private msg: ErrorMessages,private validation: validationmethod, private dialog: MatDialog
    ,private constant:constants,private restApi:RestApi,private userRoutingModule: UserRoutingModule,private linkservice: ReportlinksserviceService, private retrieveScreenAccess: RetrieveScreenAccess) {

    this.validation_messages = this.msg.etlTool;
    this.components = {
      buttonRenderer: ActionCheckBox,
      downloadbuttonRenderer: FiledownloadComponent,
      resumeLoadRenderer:ResumeLoadButton,
      ResumeExtractionRenderer:ResumeExtractionButton,
      gerateReportRenderer:GenerateReport,
      generateBttn:GenerateButton,
      generatedSplitReport:GeneratedSplitReport,
      genratedSummaryReport:GeneratedSummaryReport,
      downloadMappingFile:DownloadMappingFile,
      uploadSourceFile:FileUploadButton,
      migrationDownloadRenderer: Migrationtracelogs,
      ValidationReportDownloadRender:ValidationReportDownload,
      SummaryReportDownloadRender:SummaryReportDownload,
      loadToVaultButtonRenderer: LoadToVault,
      docAttachmentFIlePath:DocAttachmentFilePath,
      linkToCasesRenderer:LinkToCasesButton,
      deleteCaseRenderer:DeleteCaseButton,

      PopupButtonRenderer:PopupButton,
      reInitiateRenderer: ReInitiate,
      // reMigrateRenderer:ReMigrationButton

    }

  }
  columnDefsExtractTemp = [
    {
      headerName: 'Set Name',
      headerTooltip: 'Set Name',
      tooltipValueGetter: (params) => 'Set Name : ' + params.value,
      field: 'setName',
      filter: 'agTextColumnFilter',
      sort: 'asc',
      cellStyle: {textAlign: "right"},
      width: 120
    },
    {
      headerName: 'Run Instance',
      headerTooltip: 'Run Instance',
      tooltipValueGetter: (params) => 'Run Instance : ' + params.value,
      field: 'runInstance',
      filter: 'agTextColumnFilter',
      width: 120
    },
    {
      headerName: 'Current Process',
      headerTooltip: 'Current Process',
      tooltipValueGetter: (params) => 'Current Process : ' + params.value,
      field: 'activity',
      filter: 'agTextColumnFilter',
      width: 120
    },
    {
      headerName: 'Status',
      headerTooltip: 'Status',
      tooltipValueGetter: (params) => 'Status : ' + params.value,
      field: 'state',
      filter: 'agTextColumnFilter',
      width: 120
    },
    {
      headerName: 'Extraction Start',
      headerTooltip: 'Extraction Start',
      tooltipValueGetter: (params) => 'Extraction Start : ' + params.value,
      field: 'extractstartdt',
      filter: 'agTextColumnFilter',
      width: 120
    },
    {
      headerName: 'Extraction End',
      headerTooltip: 'Extraction End',
      tooltipValueGetter: (params) => 'Extraction End : ' + params.value,
      field: 'extractionenddt',
      filter: 'agTextColumnFilter',
      width: 120
    },
    {
      headerName: 'Transformation Start',
      headerTooltip: 'Transformation Start',
      tooltipValueGetter: (params) => 'Transformation Start : ' + params.value,
      field: 'tranformationstartdt',
      filter: 'agTextColumnFilter',
      width: 120
    },
    {
      headerName: 'Transformation End',
      headerTooltip: 'Transformation End',
      tooltipValueGetter: (params) => 'Transformation End : ' + params.value,
      field: 'transformationenddt',
      filter: 'agTextColumnFilter',
      width: 120
    },
    {
      headerName: 'Load Start',
      headerTooltip: 'Load Start',
      tooltipValueGetter: (params) => 'Load Start : ' + params.value,
      field: 'loadstartdt',
      filter: 'agTextColumnFilter',
      width: 120
    },
    {
      headerName: 'Load End',
      headerTooltip: 'Load End',
      tooltipValueGetter: (params) => 'Load End : ' + params.value,
      field: 'loadenddt',
      filter: 'agTextColumnFilter',
      width: 120
    },
    {
      headerName: 'Remarks',
      headerTooltip: 'Remarks',
      tooltipValueGetter: (params) => 'Remarks : ' + params.value,
      field: 'remarks',
      filter: 'agTextColumnFilter',
      width: 120
    },
    {
      headerName: 'PreLoadTransState',
      headerTooltip: 'PreLoadTransState',
      tooltipValueGetter: (params) => 'preLoadTransState : ' + params.value,
      field: 'preLoadTransState',
      filter: 'agTextColumnFilter',
      width: 120
    },
    {
      headerName: 'Log/Output Files', filter: false, cellRenderer: 'migrationDownloadRenderer',
      headerTooltip: 'Download Logs',
      cellRendererParams: {
        extractDownload: this.downloadmappingfileExtract.bind(this),
        transformDownload: this.downloadmappingfileExtract.bind(this),
        loadDownload: this.downloadmappingfileExtract.bind(this),
        vaultExtractedDownload: this.downloadmappingfileExtract.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 220
    },
    {
      headerName: 'Validation Report',
      headerTooltip: 'Validation Report',
      filter: false, cellRenderer: 'ValidationReportDownloadRender',
      cellRendererParams: {
        qlDownload: this.downloadQLfileLOader.bind(this),
        qtDownload:this.downloadQTfileLOader.bind(this),
        emrLogsDownload:this.emrLogsDownload.bind(this)
        //delete: this.deleteIcon.bind(this),
      }, width: 190
    },
    {
      headerName: 'Action',
      headerTooltip: 'Action',
      filter: false, cellRenderer: 'resumeLoadRenderer',
      cellRendererParams: {
        resumeLoadButton: this.resumeparallelLoadfile.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 120
    },
    {
      headerName: 'Resume Target Extraction',
      headerTooltip: 'Resume Target Extraction',
      filter: false, cellRenderer: 'ResumeExtractionRenderer',
      cellRendererParams: {
        resumeExtractionButton: this.resumeExtraction.bind(this),

        //delete: this.deleteIcon.bind(this),
      }, width: 120
    },
    // {
    //   headerName: 'Link Documents to Cases',
    //   headerTooltip: 'Link Documents to Cases',
    //   filter: false, cellRenderer: 'linkToCasesRenderer',
    //   cellRendererParams:{

    //     linkAttachmentsToCasesButton: this.linkToCases.bind(this),
    //     //delete: this.deleteIcon.bind(this),
    //   }, width: 120
    // },
    

    {
      headerName: 'Delete Object(s) from Target',
      headerTooltip: 'Delete Object(s) from Target',
      filter: false, cellRenderer: 'deleteCaseRenderer',
      cellRendererParams:{
        deleteCaseFromVault: this.deleteCaseFromVault.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 120
    },
    // Header for machineid
    {
      headerName: 'Machine Id',
      headerTooltip: 'Machine Id',
      tooltipValueGetter: (params) => 'Machine Id : ' + params.value,
      field: 'machineid',
      filter: 'agTextColumnFilter',
      width: 150
    },
    //hold the object group name for each set
    {
      headerName: 'Object Group Name',
      headerTooltip: 'Object Group Name',
      tooltipValueGetter: (params) => 'Object Group Name : ' + params.value,
      field: 'objectgroupname',
      filter: 'agTextColumnFilter',
      width: 150
    },

    {
      headerName: 'Start Date and Time',
      headerTooltip: 'Start Date and Time',
      tooltipValueGetter: (params) => 'Start Date and Time: ' + params.value,
      field: 'startdt',
      filter: 'agTextColumnFilter',
      width: 180
    },

    {
      headerName: 'End Date and Time',
      headerTooltip: 'End Date and Time',
      tooltipValueGetter: (params) => 'End Date and Time: ' + params.value,
      field: 'enddt',
      filter: 'agTextColumnFilter',
      width: 180
    }
  ]


  ngOnInit() {

    this.linkservice.fetchUserRole(this.localStorageSettings.getSettings("dnsName"), this.localStorageSettings.getSettings("AuthUsername")).subscribe(res => {
      console.log(res);
      this.responserequest = res;
    });

    /* modified by Chandra R
       *  calling the Userroles method to assign the rolenames for IDs in gride
       *  30-06-2024
    */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.retrieveScreenAccess.find(screenPath);
    this.linkservice.screenoperationspermission(screenPath, this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      
      let responsedata: any;
      responsedata = res;
      for (let i = 0; i < responsedata.length; i++) {

        this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
      }

      console.log('Button ID List:', this.buttonIdList);
      const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
      buttons.forEach(button => {
        const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
        if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
          if (!this.buttonIdList.includes(buttonId)) {
            button.setAttribute('disabled', 'true'); // Disable the button
          } else {
            button.removeAttribute('disabled'); // Enable the button
          }
        }
        this.gridColumnApi=this.buttonIdList
        //this.updateColumnVisibility('121',buttonIdList);
       // this.updateColumnVisibility('122',buttonIdList);

        
      });
    });

    
    this.spinnerStopping = false;
    this.formvalidations();
    this.formValidationStartRun();
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
    this.gridOptions  = {
      columnDefs: [
        {
          headerName: 'Set Name',
          headerTooltip: 'Set Name',
          tooltipValueGetter: (params) => 'Set Name : ' + params.value,
          field: 'setName',
          filter: 'agTextColumnFilter',
          sort: 'asc',
          cellStyle: {textAlign: "right"},
          width: 120
        },
        {
          headerName: 'Run Instance',
          headerTooltip: 'Run Instance',
          tooltipValueGetter: (params) => 'Run Instance : ' + params.value,
          field: 'runInstance',
          filter: 'agTextColumnFilter',
          width: 120
        },
        {
          headerName: 'Current Process',
          headerTooltip: 'Current Process',
          tooltipValueGetter: (params) => 'Current Process : ' + params.value,
          field: 'activity',
          filter: 'agTextColumnFilter',
          width: 120
        },
        {
          headerName: 'Status',
          headerTooltip: 'Status',
          tooltipValueGetter: (params) => 'Status : ' + params.value,
          field: 'state',
          filter: 'agTextColumnFilter',
          width: 120
        },
        {
          headerName: 'Extraction Start',
          headerTooltip: 'Extraction Start',
          tooltipValueGetter: (params) => 'Extraction Start : ' + params.value,
          field: 'attachmentstartdate',
          filter: 'agTextColumnFilter',
          width: 120
        },
        {
          headerName: 'Extraction End',
          headerTooltip: 'Extraction End',
          tooltipValueGetter: (params) => 'Extraction End : ' + params.value,
          field: 'attachmentenddt',
          filter: 'agTextColumnFilter',
          width: 120
        },
        {
          headerName: 'Upload to FTP Start',
          headerTooltip: 'Upload to FTP Start',
          tooltipValueGetter: (params) => 'Upload to FTP Start : ' + params.value,
          field: 'ftpstartdt',
          filter: 'agTextColumnFilter',
          width: 120
        },
        {
          headerName: 'Upload to FTP End',
          headerTooltip: 'Upload to FTP End',
          tooltipValueGetter: (params) => 'Upload to FTP End : ' + params.value,
          field: 'ftpenddt',
          filter: 'agTextColumnFilter',
          width: 120
        },
        // {
        //   headerName: 'FTP File Path',
        //   headerTooltip: 'FTP File Path',
        //   tooltipValueGetter: (params) => 'FTP File Path : ' + params.value,
        //   field: 'ftplogfilepath',
        //   filter: 'agTextColumnFilter',
        //   width: 120
        // },
        {
          headerName: 'Log/Output Files', filter: false, cellRenderer: 'downloadbuttonRenderer',
          headerTooltip: 'Log/Output Files',
          cellRendererParams: {
            docdownload: this.downloadAttachmentLogs.bind(this),
            //delete: this.deleteIcon.bind(this),
          }, width: 120
        },
      ],
    }


    this.columnDefs = [
      {
        headerName: 'Set Name',
        headerTooltip: 'Set Name',
        tooltipValueGetter: (params) => 'Set Name : ' + params.value,
        field: 'setName',
        filter: 'agTextColumnFilter',
        sort: 'asc',
        cellStyle: {textAlign: "right"},
        width: 120
      },
      {
        headerName: 'Run Instance',
        headerTooltip: 'Run Instance',
        tooltipValueGetter: (params) => 'Run Instance : ' + params.value,
        field: 'runInstance',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Current Process',
        headerTooltip: 'Current Process',
        tooltipValueGetter: (params) => 'Current Process : ' + params.value,
        field: 'activity',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'state',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Start Date and Time',
        headerTooltip: 'Start Date and Time',
        tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value,
        field: 'startdt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'End Date and Time',
        headerTooltip: 'End Date and Time',
        tooltipValueGetter: (params) => 'End Date and Time : ' + params.value,
        field: 'enddt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Extraction Start',
        headerTooltip: 'Extraction Start',
        tooltipValueGetter: (params) => 'Extraction Start : ' + params.value,
        field: 'attachmentstartdate',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Extraction End',
        headerTooltip: 'Extraction End',
        tooltipValueGetter: (params) => 'Extraction End : ' + params.value,
        field: 'attachmentenddt',
        filter: 'agTextColumnFilter',
        width: 120
      },
            {
        headerName: 'Upload to FTP Start',
        headerTooltip: 'Upload to FTP Start',
        tooltipValueGetter: (params) => 'Upload to FTP Start : ' + params.value,
        field: 'ftpstartdt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Upload to FTP End',
        headerTooltip: 'Upload to FTP End',
        tooltipValueGetter: (params) => 'Upload to FTP End : ' + params.value,
        field: 'ftpenddt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Remarks',
        headerTooltip: 'Remarks',
        tooltipValueGetter: (params) => 'Remarks : ' + params.value,
        field: 'remarks',
        filter: 'agTextColumnFilter',
        width: 120
      },
      
      // {
      //   headerName: 'FTP File Path',
      //   headerTooltip: 'FTP File Path',
      //   tooltipValueGetter: (params) => 'FTP File Path : ' + params.value,
      //   field: 'ftplogfilepath',
      //   filter: 'agTextColumnFilter',
      //   width: 120
      // },
      {
        headerName: 'Log/Output Files',
        headerTooltip: 'Log/Output Files',
        filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.downloadAttachmentLogs.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },

      {
        headerName: 'Re-Initiate', filter: false, cellRenderer: 'reInitiateRenderer',
        headerTooltip: 'Re-Initiate',
        tooltipValueGetter: (params) => 'Re-Initiate ',
        cellRendererParams: {
          reInitiate: this.reInitiateAttData.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
      // Header for machineid
      {
        headerName: 'Machine Id',
        headerTooltip: 'Machine Id',
        tooltipValueGetter: (params) => 'Machine Id : ' + params.value,
        field: 'machineid',
        filter: 'agTextColumnFilter',
        width: 150
      },
    ]

    /**
     * @modifiedby Raghottam Joshi
     * @Date 05/03/2024
     * @Note Made Re-Initiate as a Default Column
     */

    this.columnDefsExtract = [
      {
        headerName: 'Set Name',
        headerTooltip: 'Set Name',
        tooltipValueGetter: (params) => 'Set Name : ' + params.value,
        field: 'setName',
        filter: 'agTextColumnFilter',
        sort: 'asc',
        cellStyle: {textAlign: "right"},
        width: 120
      },
      
      {
        headerName: 'Current Process',
        headerTooltip: 'Current Process',
        tooltipValueGetter: (params) => 'Current Process : ' + params.value,
        field: 'activity',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'state',
        filter: 'agTextColumnFilter',
        width: 120
      },
     
      {
        headerName: 'Remarks',
        headerTooltip: 'Remarks',
        tooltipValueGetter: (params) => 'Remarks : ' + params.value,
        field: 'remarks',
        filter: 'agTextColumnFilter',
        width: 120
      },
    
      {
        headerName: 'Log/Output Files', filter: false, cellRenderer: 'migrationDownloadRenderer',
        headerTooltip: 'Download Logs',
        cellRendererParams: {
          extractDownload: this.downloadmappingfileExtract.bind(this),
          transformDownload: this.downloadmappingfileExtract.bind(this),
          loadDownload: this.downloadmappingfileExtract.bind(this),
          vaultExtractedDownload: this.downloadmappingfileExtract.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 220
      },
      {
        headerName: 'Validation Report',
        headerTooltip: 'Validation Report',
        filter: false, cellRenderer: 'ValidationReportDownloadRender',
        cellRendererParams: {
          qlDownload: this.downloadQLfileLOader.bind(this),
          qtDownload:this.downloadQTfileLOader.bind(this),
          emrLogsDownload:this.emrLogsDownload.bind(this)
          //delete: this.deleteIcon.bind(this),
        }, width: 190
      },
      {
        headerName: 'Action',
        headerTooltip: 'Action',
        filter: false, cellRenderer: 'resumeLoadRenderer',
        cellRendererParams: {
          resumeLoadButton: this.resumeparallelLoadfile.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
   
      // {
      //   headerName: 'Link Documents to Cases',
      //   headerTooltip: 'Link Documents to Cases',
      //   filter: false, cellRenderer: 'linkToCasesRenderer',
      //   cellRendererParams:{

      //     linkAttachmentsToCasesButton: this.linkToCases.bind(this),
      //     //delete: this.deleteIcon.bind(this),
      //   }, width: 120
      // },
      {
        headerName: 'Re-Initiate', filter: false, cellRenderer: 'reInitiateRenderer',
        headerTooltip: 'Re-Initiate',
        tooltipValueGetter: (params) => 'Re-Initiate ',
        cellRendererParams: {
          reInitiate: this.reInitiateCaseData.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
     
      // Header for machineid
      {
        headerName: 'Machine Id',
        headerTooltip: 'Machine Id',
        tooltipValueGetter: (params) => 'Machine Id : ' + params.value,
        field: 'machineid',
        filter: 'agTextColumnFilter',
        width: 150
      },
    ]



    this.columnDefsLoader = [
      {
        headerName: 'Set Name',
        headerTooltip: 'Set Name',
        tooltipValueGetter: (params) => 'Set Name : ' + params.value,
        field: 'setName',
        filter: 'agTextColumnFilter',
        width: 120
      },

      {
        headerName: 'Run Instance',
        headerTooltip: 'Run Instance',
        tooltipValueGetter: (params) => 'Run Instance : ' + params.value,
        field: 'runInstance',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Object Name',
        headerTooltip: 'Object Name',
        tooltipValueGetter: (params) => 'Object Name : ' + params.value,
        field: 'objectname',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'loadstatus',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'File Name',
        headerTooltip: 'File Name',
        tooltipValueGetter: (params) => 'File Name : ' + params.value,
        field: 'fileName',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Job Id',
        headerTooltip: 'Job Id',
        tooltipValueGetter: (params) => 'Job Id : ' + params.value,
        field: 'jobid',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Task Id',
        headerTooltip: 'Task Id',
        tooltipValueGetter: (params) => 'Task Id : ' + params.value,
        field: 'taskid',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Level',
        headerTooltip: 'Level',
        tooltipValueGetter: (params) => 'Level : ' + params.value,
        field: 'level',
        filter: 'agTextColumnFilter',
        width: 90
      },
      {
        headerName: 'Start Date and Time',
        headerTooltip: 'Start Date and Time',
        tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value,
        field: 'loadstartdt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'End Date and Time',
        headerTooltip: 'End Date and Time',
        tooltipValueGetter: (params) => 'End Date and Time : ' + params.value,
        field: 'loadenddt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Loader Order',
        headerTooltip: 'Loader Order',
        tooltipValueGetter: (params) => 'Loader Order : ' + params.value,
        field: 'loadorder',
        filter: 'agTextColumnFilter',
        sort: 'asc',
        width: 120
      },
      {
        headerName: 'Success Count',
        headerTooltip: 'Success Count',
        tooltipValueGetter: (params) => 'Success Count : ' + params.value,
        field: 'successcount',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Fail Count',
        headerTooltip: 'Fail Count',
        tooltipValueGetter: (params) => 'Fail Count : ' + params.value,
        field: 'failcount',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Load Action',
        headerTooltip: 'Load Action',
        tooltipValueGetter: (params) => 'Load Action : ' + params.value,
        field: 'loadAction',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Exception',
        headerTooltip: 'Exception',
        tooltipValueGetter: (params) => 'Exception : ' + params.value,
        field: 'exception',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Target Extraction Status',
        headerTooltip: 'Target Extraction Status',
        tooltipValueGetter: (params) => 'Target Extraction Status : ' + params.value,
        field: 'extractobjectstatus',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Target Extraction JobId',
        headerTooltip: 'Target Extraction JobId',
        tooltipValueGetter: (params) => 'Target Extraction JobId : ' + params.value,
        field: 'extractionJobId',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Target Extraction Exception',
        headerTooltip: 'Target Extraction Exception',
        tooltipValueGetter: (params) => 'Target Extraction Exception : ' + params.value,
        field: 'extractionException',
        filter: 'agTextColumnFilter',
        width: 120
      },
       // added one more column to identify the iddb status
      {
        headerName: 'Iddb Status',
        headerTooltip: 'Iddb Status',
        tooltipValueGetter: (params) => 'Iddb Status : ' + params.value,
        field: 'iddbstatus',
        filter: 'agTextColumnFilter',
        width: 120
      },
       // added one more column to identify the iddb status
      {
        headerName: 'Parent File Merge Status',
        headerTooltip: 'Parent File Merge Status',
        tooltipValueGetter: (params) => 'Parent File Merge Status : ' + params.value,
        field: 'parentfilemergestatus',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Success Log',
        headerTooltip: 'Success Log',
        filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.docdownloadSuccess.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },

      {
        headerName: 'Failure Log',
        headerTooltip: 'Failure Log',
        filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.docdownloadFailure.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
      {
        headerName: 'Upload Source file',
        headerTooltip: 'Upload Source file',
        filter: false, cellRenderer: 'uploadSourceFile',
        cellRendererParams: {
          uploadSourceFile: this.uploadloaderfile.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
      {
        headerName: 'Action',
        headerTooltip: 'Action',
        filter: false, cellRenderer: 'resumeLoadRenderer',
        cellRendererParams: {
          resumeLoadButton: this.resumeLoadfile.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
    ]

    this.columnDefsLoadAttachment = [

      {
        headerName: 'Load To Vault', filter: false, cellRenderer: 'loadToVaultButtonRenderer',
        headerTooltip: 'Load To Vault',
        cellRendererParams: {
          docdownload: this.loadToVault.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 100
      },
      {
        headerName: "Set Id",
        headerTooltip: "Set Id",
        tooltipValueGetter: params => "Set Id : " + params.value,
        field: "setId",
        filter: "agTextColumnFilter",
        width: 120
      },
      {
        headerName: "Run Id",
        headerTooltip: "Run Id",
        tooltipValueGetter: params => "Run Id : " + params.value,
        field: "runId",
        filter: "agTextColumnFilter",
        width: 120
      },
      {
        headerName: "Attachment Type",
        headerTooltip: "Attachment Type",
        tooltipValueGetter: params => "Attachment Type : " + params.value,
        field: "attachmentType",
        filter: "agTextColumnFilter",
        width: 120
      },
      {
        headerName: "File Name",
        headerTooltip: "File Name",
        tooltipValueGetter: params => "File Name : " + params.value,
        cellRenderer: 'docAttachmentFIlePath',
        cellRendererParams: {
          downloadgeneratedSummaryReport: this.downloadDocAttachmentFilePath.bind(this)
          //delete: this.deleteIcon.bind(this),
        },
        width: 120
      },

      {
        headerName: "File Creation",
        headerTooltip: "File Creation",
        tooltipValueGetter: params => "File Creation : " + params.value,
        field: "loaderFileCreation",
        filter: "agTextColumnFilter",
        width: 120
      },
      {
        headerName: "Vault Load Status",
        headerTooltip: "Vault Load Status",
        tooltipValueGetter: params => "Vault Load Status : " + params.value,
        field: "loadToVault",
        filter: "agTextColumnFilter",
        width: 120
      },
      {
        headerName: "Attachment Count",
        headerTooltip: "Attachment Count",
        tooltipValueGetter: params => "Attachment Count : " + params.value,
        field: "attachmentCount",
        filter: "agTextColumnFilter",
        width: 120
      },
      {
        headerName: 'Job Id',
        headerTooltip: 'Job Id',
        tooltipValueGetter: (params) => 'Job Id : ' + params.value,
        field: 'jobId',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Task Id',
        headerTooltip: 'Task Id',
        tooltipValueGetter: (params) => 'Task Id : ' + params.value,
        field: 'taskId',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: "Success Log Count",
        headerTooltip: "Success Log Count",
        tooltipValueGetter: params => "Success Log Count : " + params.value,
        field: "successCount",
        filter: "agTextColumnFilter",
        width: 120
      },
      {
        headerName: "Failure Log Count",
        headerTooltip: "Failure Log Count",
        tooltipValueGetter: params => "Failure Log Count : " + params.value,
        field: "failureCount",
        filter: "agTextColumnFilter",
        width: 120
      },
      {
        headerName: "Exception",
        headerTooltip: "Exception",
        tooltipValueGetter: params => "Exception : " + params.value,
        field: "exception",
        filter: "agTextColumnFilter",
        width: 120
      },
      {
        headerName: "Created By",
        headerTooltip: "Created By",
        tooltipValueGetter: params => "Created By : " + params.value,
        field: "createdBy",
        filter: "agTextColumnFilter",
        width: 120
      },
      {
        headerName: "Created Date And Time",
        headerTooltip: "Created Date And Time",
        tooltipValueGetter: params => "Created Date And Time : " + params.value,
        field: "createdDateAndTime",
        filter: "agTextColumnFilter",
        width: 120
      },

      {
        headerName: 'Success Log',
        headerTooltip: 'Success Log',
        filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.docAttachmentdownloadSuccess.bind(this),
          //delete: this.deleteIcon.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 100
      },

      {
        headerName: 'Failure Log',
        headerTooltip: 'Failure Log',
        filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.docAttachmentdownloadFailure.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 100
      },


    ];
    /**
     * @modifiedby Raghottam Joshi
     * @Date 05/03/2024
     * @Note Made Migration Type as a Default Column
     */

    this.columnDefsFormigration = [{
      headerName: "Migration Id",
      headerTooltip: "Migration Id",
      tooltipValueGetter: params => "Migration Id : " + params.value,
      field: "migrationId",
      filter: "agTextColumnFilter",
      width: 120
    },
    // added column in run history grid for comments
    {
      headerName: 'Description',
      headerTooltip: 'Description',
      tooltipValueGetter: (params) => 'Description : ' + params.value,
      field: 'comment',
      filter: 'agTextColumnFilter',
      width: 200
    },
    {
      headerName: 'Start Date and Time',
      headerTooltip: 'Start Date and Time',
      tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value,
      field: 'startdt',
      filter: 'agTextColumnFilter',
      width: 180
    },
    {
      headerName: 'End Date and Time',
      headerTooltip: 'End Date and Time',
      tooltipValueGetter: (params) => 'End Date and Time : ' + params.value,
      field: 'enddt',
      filter: 'agTextColumnFilter',
      width: 180
    },
    {
      headerName: 'Status',
      headerTooltip: 'Status',
      tooltipValueGetter: (params) => 'Status : ' + params.value,
      field: 'state',
      filter: 'agTextColumnFilter',
      sort: "desc",
      width: 120
    },
    {
      headerName: 'Services Assigned', filter: false, cellRenderer: 'generateBttn',
      headerTooltip: 'Services Assigned',
      tooltipValueGetter: (params) => 'Services Assigned',
      cellRendererParams: {
        generateReport: this.selectService.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 120
    },
    {
      headerName: 'Migration Type',
      headerTooltip: 'Migration Type',
      tooltipValueGetter: (params) => 'Migration Type : ' + params.value,
      field: 'migrationType',
      filter: 'agTextColumnFilter',
      width: 200
    },
    {
      headerName: 'Remarks',
      headerTooltip: 'Remarks',
      tooltipValueGetter: (params) => 'Remarks : ' + params.value,
      field: 'remarks',
      filter: 'agTextColumnFilter',
      width: 200
    },
   
  ];
    /**
     * @modifiedby SaiNaveen Somaraju
     * @Date 20/06/2023
     * @Note Headers for the Global Data screen
     */
    this.columnHeaderForGlobalTab = [
      {
        headerName: 'Set Name',
        headerTooltip: 'Set Name',
        tooltipValueGetter: (params) => 'Set Name : ' + params.value,
        field: 'setName',
        filter: 'agTextColumnFilter',
        sort: 'asc',
        cellStyle: {textAlign: "right"},
        width: 150
      },
      {
        headerName: 'Run Instance',
        headerTooltip: 'Run Instance',
        tooltipValueGetter: (params) => 'Run Instance : ' + params.value,
        field: 'runInstance',
        filter: 'agTextColumnFilter',
        width: 150
      },
      {
        headerName: 'Current Process',
        headerTooltip: 'Current Process',
        tooltipValueGetter: (params) => 'Current Process : ' + params.value,
        field: 'activity',
        filter: 'agTextColumnFilter',
        width: 150
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'state',
        filter: 'agTextColumnFilter',
        width: 150
      },
      {
        headerName: 'Extraction Start',
        headerTooltip: 'Extraction Start',
        tooltipValueGetter: (params) => 'Extraction Start : ' + params.value,
        field: 'extractstartdt',
        filter: 'agTextColumnFilter',
        width: 150
      },
      {
        headerName: 'Extraction End',
        headerTooltip: 'Extraction End',
        tooltipValueGetter: (params) => 'Extraction End : ' + params.value,
        field: 'extractionenddt',
        filter: 'agTextColumnFilter',
        width: 150
      },
      // {
      //   headerName: 'Upload to S3 Start',
      //   headerTooltip: 'Upload to S3 Start',
      //   tooltipValueGetter: (params) => 'Upload to S3 Start : ' + params.value,
      //   field: 'ftpstartdt',
      //   filter: 'agTextColumnFilter',
      //   width: 120
      // },
      // {
      //   headerName: 'Upload to S3 End',
      //   headerTooltip: 'Upload to S3 End',
      //   tooltipValueGetter: (params) => 'Upload to S3 End : ' + params.value,
      //   field: 'ftpenddt',
      //   filter: 'agTextColumnFilter',
      //   width: 120
      // },
      {
        headerName: 'Remarks',
        headerTooltip: 'Remarks',
        tooltipValueGetter: (params) => 'Remarks : ' + params.value,
        field: 'remarks',
        filter: 'agTextColumnFilter',
        width: 150,
      },
      {
        headerName: 'Log/Output Files',
        headerTooltip: 'Log/Output Files',
        filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.downloadAttachmentLogs.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 150
      },

      {
        headerName: 'Re-Initiate', filter: false, cellRenderer: 'reInitiateRenderer',
        headerTooltip: 'Re-Initiate',
        tooltipValueGetter: (params) => 'Re-Initiate ',
        cellRendererParams: {
          reInitiate: this.reInitiateGlobalData.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
      {
        headerName: 'Machine Id',
        headerTooltip: 'Machine Id',
        tooltipValueGetter: (params) => 'Machine Id : ' + params.value,
        field: 'machineid',
        filter: 'agTextColumnFilter',
        width: 150
      },
    ];

    this.columnDefsExtractionAndTransformation = [
      {
        headerName: 'Set Name',
        headerTooltip: 'Set Name',
        tooltipValueGetter: (params) => 'Set Name : ' + params.value,
        field: 'setid',
        filter: 'agTextColumnFilter',
        width: 150
      },

      {
        headerName: 'Run Instance',
        headerTooltip: 'Run Instance',
        tooltipValueGetter: (params) => 'Run Instance : ' + params.value,
        field: 'migrationid',
        filter: 'agTextColumnFilter',
        width: 150
      },
      {
        headerName: 'Object Name',
        headerTooltip: 'Object Name',
        tooltipValueGetter: (params) => 'Object Name : ' + params.value,
        field: 'objectname',
        filter: 'agTextColumnFilter',
        width: 150,
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'state',
        filter: 'agTextColumnFilter',
        width: 150
      }, {
        headerName:'Activity',
        headerTooltip:'Activity',
        tooltipValueGetter: (params) => 'Activity : ' + params.value,
        field: 'activity',
        filter: 'agTextColumnFilter',
        width: 150
      },
      {
        headerName: 'Execution Start Date',
        headerTooltip: 'Execution Start Date',
        tooltipValueGetter: (params) => 'Execution Start Date : ' + params.value,
        field: 'executionstartdate',
        filter: 'agTextColumnFilter',
        width: 150
      },
      {
        headerName: 'Execution End Date',
        headerTooltip: 'Execution End Date',
        tooltipValueGetter: (params) => 'Execution End Date : ' + params.value,
        field: 'executionenddate',
        filter: 'agTextColumnFilter',
        width: 150
      },
      {
        headerName: 'Execution Order',
        headerTooltip: 'Execution Order',
        tooltipValueGetter: (params) => 'Execution Order : ' + params.value,
        field: 'extractorder',
        filter: 'agTextColumnFilter',
        sort: 'asc',
        width: 150
      },
      {
        headerName: 'Exception',
        headerTooltip: 'Exception',
        tooltipValueGetter: (params) => 'Exception : ' + params.value,
        field: 'exception',
        filter: 'agTextColumnFilter',
        width: 150
      },
      
    ]

    // if the record has status==no , row color will change
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
      filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true,
      alwaysShowHorizontalScroll: true,
    };
    this.rowSelection= 'single',
      this.rowSelectionForTablesFields = "single",
      this.rowMultiSelectWithClick= true,
      this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    this.startmigration="";
    this.retriveMappingFile();
    this.retrieveMigrationLog();
    this.retrieveJsuiteValue();
    this.defferedSet();
    this.defferedObjects();

    // Auto refresh grid code start
    // {
    // this.updateSubscription = interval(30000).subscribe(
    //   (val) => { this.onGridReadyCaseData(this.tempextractparams)});
    // // Auto refresh grid code end
    // }
  }

  updateColumnVisibility(columnId,buttonIdList) {
    if (this.gridColumnApi) { // Ensure column API exists
      if (buttonIdList.includes(columnId)) {
          this.gridColumnApi.setColumnsVisible(columnId, true);  // Show column
      } else {
          this.gridColumnApi.setColumnsVisible(columnId, false); // Hide column
      }
  }
  }

  //excel export function
  onDownloadRunhistory(){
    this.gridmgrnAPI.exportDataAsCsv();
  }

  onBtExport() {
    this.gridAPI.exportDataAsCsv();
  }

  onDownloadLoad(){
    this.gridAPIValidation.exportDataAsCsv();
  }

  refreshVaultObjects(){
    let width = "55%";
    let dialogRef = this.dialog.open(EtllibraryobjectsComponent, {
      maxWidth: '100vw',
      height: "70%",
      width: width,
      data:{},
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }


  applyFilters(){
    let width = "55%";
    let dialogRef = this.dialog.open(EtlfiltersComponent, {
      maxWidth: '100vw',
      height: "70%",
      width: width,
      data:{},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  refreshRun(){
    this.spinner.start();
    this.onGridReadymigration(this.temprunHistory);
    this.refresh();
    this.spinner.stop();
  }

  /**
   * @author SaiNaveen Somaraju
   * @Date : 31/07/2023
   * This method will be called when we click on the refresh button on third grid(object grid)
   * in this method we will check the what is the current activity was opened to the user and with that we will call the api one that are with migrationtraceid
   */
  refreshObjects(){
    this.spinner.start();
    try{
      // if migrationtrace id is presetnt then call api by migrationtraceid
      if(this.currentMigrationTraceIdInMigrationGrid){
         /*  
             * @modified by Shantanu Ghate
             * @Date 28-03-2026
             * added the condition for AuditTrailExtraction
          */
        if(this.currentActivityInObjectGrid=="Extraction" || this.currentActivityInObjectGrid=="Transform"||this.currentActivityInObjectGrid=="GlobalExtraction"||this.currentActivityInObjectGrid=="AttachmentExtraction" || this.currentActivityInObjectGrid=="AuditTrailExtraction"){
          this.onGridReadyThirdGridDataForExtractionAndTransformation(this.vaultvalidationAPI)
        }
        else if(this.currentActivityInObjectGrid=="Load"){
          this.onGridReadyVaultValidation(this.vaultvalidationAPI)
        }
        else if(this.currentActivityInObjectGrid=="AttachmentLoadToFTP"){
          this.retrieveAttachmentsBasedOnMigrationTraceId()
        }
      }
      // if migrationtrace id is not available then we have another api to get the same data
      else{
         /*  
             * @modified by Shantanu Ghate
             * @Date 28-03-2026
             * added the condition for AuditTrailExtraction
          */
        if(this.currentActivityInObjectGrid=="Extraction"|| this.currentActivityInObjectGrid=="Transform"||this.currentActivityInObjectGrid=="GlobalExtraction"||this.currentActivityInObjectGrid=="AttachmentExtraction" || this.currentActivityInObjectGrid=="AuditTrailExtraction"){
          this.retrieveInstructionsBasedOnActivity(this.vaultvalidationAPI)
        }
        else if(this.currentActivityInObjectGrid=="Load"){
          this.retrieveInstructionsBasedOnActivity(this.vaultvalidationAPI)
        }
        else if(this.currentActivityInObjectGrid=="AttachmentLoadToFTP"){
            this.retrieveAttachmentsBasedOnMigrationTraceId()
        }
      }
    }
    catch(e){
      console.log(e)
    }
    this.spinner.stop();
  }

/**
 * @Note When ever we change the radio button in second(set level) grid this method will be called
 * in this method we are changing the grid according to the activity
 * @param value
 */
   caseData(value){
    this.migrationTraceRadioSelection = value;
    try{
    this.spinner.start();
    this.gridDataValidation=[];
    this.gridAPIValidation=this.tempextractparams.api
    this.gridAPIValidation.setGridOption('rowData', [])
    console.log();
    console.log(value);
    if(value == 'Attachments') {
      //setting the transform radio button off in the third grid
      this.isDisableTransformbtn=true;
      this.isDisableLoadbtn=false;

      this.loadingProcess="Attachments"
      // this.migrationType="ETL_Attachments";
      this.uploadisDisable = false;
      console.log(this.loadingProcess);
      this.migrationParentId = this.migrationSelectedId;
      this.gridattachmentData=[];
      
     /*
    * @Modified by Renuka chama
    * @Date 04/08/2025
    * For old view hide startdt & enddt
    * For new view hide extract and ftp columns
    */
    setTimeout(() => {
      if (this.gridColumnAPI) {
        const availableFields = this.gridColumnAPI.getColumns().map(c => c.getColDef().field);
        console.log('available fields:', availableFields);

    // For old view hide startdt & enddt
    if (this.selectedGrid === 'old') {
      const columnsToHide: string[] = [];
      ['startdt', 'enddt'].forEach(col => {
        if (availableFields.includes(col)) {
            columnsToHide.push(col);
          // this.gridColumnAPI.setColumnVisible(col, false);
        } else {
          console.warn(`Column not found`);
        }
      });
      if(columnsToHide.length > 0){
        this.gridAPI.setColumnsVisible(columnsToHide, false);
      }
    }
    // For new view hide extract and ftp columns
    if (this.selectedGrid === 'new') {
        const columnsToHideFornew: string[] = [];
      ['attachmentstartdate', 'attachmentenddt', 'ftpstartdt', 'ftpenddt'].forEach(col => {
        if (availableFields.includes(col)) {
          // this.gridColumnAPI.setColumnVisible(col, false);
          columnsToHideFornew.push(col);
        } else {
          console.warn(`Column not found`);
        }
      });
      if(columnsToHideFornew.length > 0){
        this.gridAPI.setColumnsVisible(columnsToHideFornew, false);
      }
    }
  }
  this.spinner.stop();
}, 100);

      this.onGridReadyAttachmentsData(this.transformApi)
     
    } 
    /*
    * @Modified by SaiNaveen Somarajung
    * @Date 20/06/2023
    * @Note to check the Global extraction check box is selected 
    * or not if selected go with the global extracton records
    */
    else if(value=="GlobalData"){
      //make extraction alway selected for global data in third grid
      this.objectRadioValue="extractionObjects"

      //setting transform and load radio button off in third grid
      this.isDisableTransformbtn=true;
      this.isDisableLoadbtn=true;
      

      this.migrationParentId = this.migrationSelectedId;
      this.loadingProcess="GlobalData"
      // this.migrationType="ETL";
      this.uploadisDisable = false;
      console.log(this.loadingProcess);
      this.migrationParentId = this.migrationSelectedId;
      this.onGridReadyGlobalData(this.tempglobalextractparams)
      this.spinner.stop();
    }
    else {
      //setting extraction,transform and load raadio button turned on in the third grid
      this.isDisableLoadbtn=false;
      this.isDisableTransformbtn=false;
      this.loadingProcess="CaseData"
      // this.migrationType="ETL";
      this.uploadisDisable = true;
      console.log(this.loadingProcess);
      console.log(this.migrationSelectedId);
      this.migrationParentId = this.migrationSelectedId;
      console.log(this.migrationParentId);
      this.gridData=[];
      this.onGridReadyCaseData(this.tempextractparams);

    }

  }
  catch(e){
    this.spinner.stop()
   console.log(e)
  }
  }
  /**
   * @author SaiNaveen Somaraju
   * @Date 20/06/2023
   * @note Added one method for display globalextraction records on screen ready 
   * @param params 
   */
  onGridReadyGlobalData(params) {
    console.log("--12--")
    this.extractionType = "GlobalExtraction";
    this.migrationTrace = false;
    this.globaltrace = true;
    this.transformTrace = false;
    this.gridData = [];
    this.tempglobalextractparams = params
    this.gridAPI = params.api;
    this.gridColumnAPI = params.api;
    this.gridAPI.setGridOption('rowData', [])
    this.spinner.start();
    // this.migrationType = "ETL";
    
    this.service.retrieveMigrationGlobalTrace(this.localStorageSettings.getSettings("dnsName"), this.migrationParentId, this.migrationType, this.extractionType).subscribe((response) => {
      console.log(response);
      this.gridData = response;
      if (this.gridData.length === 0) {
        this.gridAPI.setGridOption('rowData', []);
        this.spinner.stop();
      } else {
        this.tempextdata = [];
        this.globalExtractionData = [];
        for (const element of this.gridData) {

          if (element.migrationid == this.migrationParentId) {
            element.setName = element.setid;
            element.runInstance = "Run_" + element.migrationid;
            this.tempextdata = element;
            this.globalExtractionData.push(this.tempextdata);
          }
        }
        console.log("Global data : " + this.globalExtractionData);
        this.gridAPI.setGridOption('rowData', this.globalExtractionData);
        this.spinner.stop();
      }
    })
  }
  
  
  


  
  onGridReadyGlobalDataNew(params) {
    this.extractionType = "GlobalExtraction";
    this.migrationTrace = false;
    this.globaltrace = true;
    this.transformTrace = false;
    this.gridData = [];
    this.tempglobalextractparams = params
    this.gridAPI = params.api;
    this.gridColumnAPI = params.api;
    this.gridAPI.setGridOption('rowData', [])
    this.spinner.start();
    // this.migrationType = "ETL";
    this.service.retrieveMigrationGlobalTrace(this.localStorageSettings.getSettings("dnsName"), this.migrationParentId, this.migrationType, this.extractionType).subscribe((response) => {
      console.log(response);
      this.gridData = response;
      if (this.gridData.length === 0) {
        this.gridAPI.setGridOption('rowData', []);
        this.spinner.stop();
      } else {
        this.tempextdata = [];
        this.globalExtractionData = [];
        for (const element of this.gridData) {

          if (element.migrationid == this.migrationParentId) {
            element.setName = element.setid;
            element.runInstance = "Run_" + element.migrationid;
            this.tempextdata = element;
            this.globalExtractionData.push(this.tempextdata);
          }
        }
        console.log("Global data : " + this.globalExtractionData);
        this.gridAPI.setGridOption('rowData', this.globalExtractionData);
        this.spinner.stop();
      }
    })
  }

  switch(){
    
    this.refresh()
  }


  refresh(){
    this.setSelect = false;
    this.spinner.start();
    this.loadsetId=[];
    console.log(this.loadingProcess);
    if(this.loadingProcess==="Attachments"){
      this.gridattachmentData=[];
      this.onGridReadyAttachmentsData(this.transformApi)
    }else if(this.loadingProcess ==="CaseData"){
      this.gridData=[];
      console.log(this.tempextractparams)
      this.onGridReadyCaseData(this.tempextractparams)
    }
    else if(this.loadingProcess=="GlobalData"){
      this.gridData=[];
      this.onGridReadyGlobalData(this.tempglobalextractparams)
    }
    this.gridAPIValidation.setGridOption('rowData', [])

  }

  formvalidations() {
    this.FormValid = new UntypedFormGroup({
      imageName: new UntypedFormControl(''),
      imageupload: new UntypedFormControl('')
    });
    // Updated form fields for set size and migration sets fields by kalpesh 11-08-2022
    this.FormValidS3 = new UntypedFormGroup({
      defferedSets: new UntypedFormControl(this.defferedData.defferedSets),
      defferedObjects: new UntypedFormControl(this.defferedData.defferedObjects),
      migrationSets: new UntypedFormControl(this.defferedData.migrationSets),
      setSize: new UntypedFormControl(this.defferedData.setSize)
    });

  }
  formValidationStartRun(){
    this.FormValidStartRun = new UntypedFormGroup({
      globalCheckbox:new UntypedFormControl(''),
      extractionCheckbox: new UntypedFormControl(''),
      transformationCheckbox: new UntypedFormControl(''),
      preloadtransformationCheckbox: new UntypedFormControl(''),
      loadCheckbox: new UntypedFormControl(''),
      validationCheckbox: new UntypedFormControl(''),
      attachextractCheckbox: new UntypedFormControl(''),
      ftpuploadCheckbox: new UntypedFormControl('')
    });
  }
  etlProcess: ETLProcess[] = [
    { name: 'Extraction', value: 'Extraction' },
    { name: 'Transformation', value: 'Transform'},
    { name: 'Load', value: 'Loader'},
    { name: 'Validation Report', value: 'validationReport'},
  ];

  readThisimage(inputValue: any,filecheck:any): void {
    let ischeckfile=false
    var file: File = inputValue.files[0];
    var FileS: File = inputValue.files[0];
    console.log(file.type)
    let flag:boolean= this.commonTs.hasMultipleExtensions(file);

    if(filecheck==='csv'){
      if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
        ischeckfile=true
      }
    }
    if (!flag&&ischeckfile) {
    /**
   * ModifiedBy Abhishek T
   * @Date 21-11-2023
   * @Desc Removing file size limit
   */
        var fileName = FileS.name;
        //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

        var photo: FileReader = new FileReader();
        photo.onloadend = e => {
          var img = photo.result;
          console.log(photo.result);
          var photobase64result = photo.result.toString().split(",", 2)[1];

          // this is to check the file is empty or not
          this.imagephoto = photo.result.toString();
          this.imagephotoshow = true;
          // this.statevaluechange.fileData = photobase64result;
          // this.statevaluechange.fileName = fileName;
          // this.FormValid.controls.imageName.setValue(fileName);
          console.log(this.statevaluechange)
          if(this.compare == this.statevaluechange.fileData){
            console.log("same")
          }
          // (<HTMLInputElement>document.getElementById('file-path')).value= fileName;

        };
        photo.readAsDataURL(file);
      } 
     else {
      this.snackbar.open(file.name + "is invalid file. Please select Excel file ", "OK", {
        duration: 5000,
      });
    }
  }

  mappingFiletoS3($event,filecheck): void {
    this.readThisimage($event.target,filecheck);
  }

  retrieveJsuiteValue(){
    this.dnsId = localStorage.getItem("dnsName");
    console.log(this.dnsId);
    let dnsid = this.dnsId
    let propertyValue = "ObjectLoadType";
    this.service.retrieveJsuiteProperty(dnsid, propertyValue).subscribe(res=>{
      console.log("Test string");
      console.log(res)
      this.jsuiteValue = res;
      console.log(this.jsuiteValue);
      console.log(this.jsuiteValue.propertyvalue);
      // Coverting string to loawercase to check the condition in resume load and uploading file
      this.jsuitepropertyValue = this.jsuiteValue.propertyvalue.toLowerCase();
    });
  }

  // Function to retrieve Deffered sets, migration sets and set size values. Written by kalpesh
  defferedSet(){
    this.dnsId = this.localStorageSettings.getSettings("dnsName");
    console.log(this.dnsId);
    this.service.retrieveDefferedSets(this.dnsId).subscribe(res=>{
      console.log(res)
      this.defferedSetData = res;
      console.log(this.defferedSetData);
      for(let i=0; i<this.defferedSetData.length; i++){
        console.log(this.defferedSetData.deferredsets);
        this.defferedData.defferedSets = this.defferedSetData[i].deferredsets;
        this.defferedData.setSize = this.defferedSetData[i].setsize;
        this.defferedData.migrationSets = this.defferedSetData[i].noofsets;
      }
    });
  }

  // Function to retrieve Deffered objects. Written by kalpesh
  defferedObjects(){
    this.dnsId = this.localStorageSettings.getSettings("dnsName");
    console.log(this.dnsId);
    this.service.retrieveDefferedObjects(this.dnsId).subscribe(res=>{
      console.log(res)
      this.defferedObjectData = res;
      console.log(this.defferedObjectData);
      for(let i=0; i<this.defferedObjectData.length; i++){
        if(this.defferedObjectData[i].deferred == "true"){
          this.alldefferedObjects.push(this.defferedObjectData[i].objectname)
          console.log(this.alldefferedObjects);
          this.defferedData.defferedObjects = this.alldefferedObjects;
        }
      }
    });
  }
  
retrieveSourceAndTarget() {
  console.log("Calling retrieveSourceAndTarget");
  const dnsId = "27";
  this.spinner.start();
  this.service.retrieveSourceAndTraget(dnsId, "Source").subscribe({
    next: (result) => {
      console.log(result);
      if (result === null) {
        console.log("No Data Found");
      } else {
        console.log(result.sourceEnvName)
        this.selectedSourceName = result.sourceEnvName;
        console.log(this.selectedSourceName)
        this.selectedSource = this.selectedSourceName
        this.selectedTarget = result.targetEnvName
        this.SourceId = result.sourceId
        this.targetId = result.targetId
        console.log( result.targetEnvName)
        console.log(this.selectedTarget)
        this.migrationSelectedType = result.mappingTypeName
        this.sourceSystemTypeName = result.sourceSystemName
        // this.validations_form.get('source')?.setValue(this.selectedSource);
        // this.validations_form.get('target')?.setValue(this.selectedTarget);
        // this.validations_form.get('migrationType')?.setValue(this.migrationSelectedType);
        // this.onSourceSelection()
        // this.migrationTypeRetrieved()
      //  this.checkForObjectNames();
        
      }
      this.spinner.stop();
    },
    error: (err) => {
      console.error("Error snapshotDetails:", err);
      this.spinner.stop();
    }
  });
}
selectedRowData: any;

onCellContextMenu(event: any) {
  this.selectedRowData = event.data;
  console.log(event)
}
/**
 * @Author: Venkata Shyam
 * @Date: 02/05/2025
 * @note: implemented edit functionality for migration run popup to change only the mapping file for migration which is In Progress
 */
edit(){
  console.log(this.selectedRowDataFromGrid.data)
  const selectedData = this.selectedRowDataFromGrid.data;

  // Prepare the data to be sent to the popup for editing
  const editData = {
    selectedSourceName: selectedData.sourcedns,
    selectedTarget: selectedData.targetdns,
    SourceId: selectedData.sourceId,
    TargetId: selectedData.targetId,
    MigrationType: selectedData.migrationType,
    sourceSystemTypeName: selectedData.sourceSystemName,
    migrationId: selectedData.migrationId,
    comment : selectedData.comment,
    dataLakeAndReports: selectedData.dataLakeAndReports,
    dataextractiontype: selectedData.dataextractiontype,
    datalakeType: selectedData.datalakeType,
    jsontocsvvalidationreports:selectedData.jsontocsvvalidationreports,
    mappingFilePath:selectedData.mappingFilePath,
    mappingfileversion:selectedData.mappingfileversion
    // Add any other fields you want to pass to the popup for editing
  };

  // Open the popup with the selected data
  let dialogRef = this.dialog.open(EtlMigrationPopupComponent, {
    maxWidth: '100vw',
    maxHeight: '100vh',
    height: "85%",
    width: "85%",
    panelClass: 'full-screen-dialog',
    data: editData, // Send the selected data for editing
    disableClose: true
  });
  dialogRef.afterClosed().subscribe(result => {
    console.log(result);

    if (result && result.data) {
      let editedMigrationData = result.data;
      let edittedMappingdata ={
        mappingfilename: editedMigrationData.mappingfileData.mappingFileName,
        mappingfileData: editedMigrationData.mappingfileData.mappingFileData,
        dnsId: this.localStorageSettings.getSettings("dnsName"),
        migrationid:editedMigrationData.migrationid,
        mappingfileversion:editedMigrationData.mappingFileversion
      }
      this.statevaluechange.fileData = edittedMappingdata.mappingfileData;
      this.statevaluechange.fileName = edittedMappingdata.mappingfilename;
      this.FormValid.controls.imageName.setValue(edittedMappingdata.mappingfilename);
      this.mappingfileversion = edittedMappingdata.mappingfileversion
      this.migrationid = edittedMappingdata.migrationid
      this.uploadFile();
      this.updateMigrationforMappingversion();
      // this.retriveMappingFile();
    }
  });
}
updateMigrationforMappingversion(){
  console.log(this.migrationid,this.mappingfileversion)
  this.service.updateMappingfileversion(this.migrationid,this.mappingfileversion).subscribe(
    result => {
        console.log(result);
        if (result===null) {
            // this.snapshotDetails = ["No Snapshot Details Found"];
            console.log("No Data Found")
        } else {
           
            
        }
        
        // this.snapshotSelected = 'DM_Mappingfile_101';
        // this.validations_form_input.patchValue({
        //   snapshotVersion: this.snapshotSelected
        // });
        // this.onMappingSnapshotChange(this.snapshotSelected);
  
        // this.spinner.stop();
    },
    error => {
        console.error("Error snapshotDetails :", error);
        // this.snapshotDetails = [];
        this.spinner.stop();
    }
);
}
compare
start() {
  console.log("Start button clicked");
  // const dnsId= "27"
  const dnsId = this.localStorageSettings.getSettings("WorkspaceId");

  
  this.spinner.start();
  // console.log(event)
  this.service.retrieveSourceAndTraget(dnsId, "Source").subscribe({
    next: (result) => {
      if (result !== null) {
        const popupData = {
          selectedSourceName: result.sourceEnvName,
          selectedTarget: result.targetEnvName,
          SourceId: result.sourceId,
          TargetId: result.targetId,
          MigrationType: result.mappingTypeName,
          sourceSystemTypeName: result.sourceSystemName,
          targetSystemTypeName :result.targetSystemName
        };
//         let width = '65%';
//         let height = '80%';
        
//         if (result.mappingTypeName === "DataVirtualization") {
//           width = '100vw';
//           height = '100vh';
// // Bigger, because dropdowns will be there
//         } else if (result.mappingTypeName === "DataMigration") {
//           width = '70%';
//           height = '80%';
//         } else {
//           width = '65%';
//           height = '75%';
//         }
        
        
        // let width = "65%";
        if (this.mgrid === undefined || this.mgrid === '' || this.mgrid === null) {
          let dialogRef = this.dialog.open(EtlMigrationPopupComponent, {
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: "85%",
            width: "85%",
            panelClass: 'full-screen-dialog', 
            data: popupData,   // send correct data here
            disableClose: true
          });

          dialogRef.afterClosed().subscribe(result => {
            console.log(result);
           this.selectedObjectGroups=result.data.selectedObjectGroups;
           console.log(this.selectedObjectGroups);
            let startMigrationData = result.data;
            this.migrationType = startMigrationData.migrationType;
            let startMigrationRequest = {
              mappingfileversion:startMigrationData.mappingFileversion,
              mappingfilename:startMigrationData.mappingfileData.mappingFileName,
              mappingfileData:startMigrationData.mappingfileData.mappingFileData,
              dnsId: this.localStorageSettings.getSettings("dnsName"),
              migrationType: startMigrationData.migrationType,
              fileName: startMigrationData.fileData.fileName,
              fileData: startMigrationData.fileData.fileData,
              dataExtractionType: startMigrationData.dataExtractionType,
              sourcedns: startMigrationData.source,
              targetdns:startMigrationData.target,
              comment: startMigrationData.remarks,
              selectedObjectGroups:startMigrationData.selectedObjectGroups,
              datasetname:startMigrationData.DatasetName,
              dataLakeAndReports:startMigrationData.dataLakeAndReports,
              datalakeType:startMigrationData.dataLakeType,
              persistenceEmr:startMigrationData.persistenceEmr,
              persistenceClusterId:startMigrationData.persistenceClusterId,
              jsontocsvvalidationreports:startMigrationData.JSONTOCSV_Validation_Reports,
              sourceextractiontype: startMigrationData.sourceextractiontype
            }
            console.log(startMigrationRequest);
            this.compare = startMigrationRequest.mappingfileData
            this.statevaluechange.fileData = startMigrationRequest.mappingfileData
            this.statevaluechange.fileName = startMigrationRequest.mappingfilename
            this.FormValid.controls.imageName.setValue(startMigrationRequest.mappingfilename);
            this.spinner.start();
            // this.uploadFile();
            console.log(startMigrationRequest);

            
            // Add confirmation BEFORE starting migration
              if (!confirm("Are you sure you want to overwrite the existing file?")) {
                  this.cancel();
                  this.snackbar.open("Migration cancelled", "OK", { duration: 5000 });
                  this.spinner.stop();
                  return; // ← KEY: Stop execution here
              }
            this.service.startmigration(startMigrationRequest).subscribe(res => {
              console.log(res);
              if (res.error === true) {
                this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
                this.spinner.stop();
              } else {
                this.spinnerStopping =true;
                 this.uploadFile();
                this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
                this.retrieveMigrationLog();
                // this.retriveMappingFile();
              }
              // this.spinner.stop();
            });
          });

        } else {
          this.snackbar.open("Migration for Data Virtualization or Data Migration is active, please abort active migrations and try again", "OK", { duration: 5000 });
        }
      } else {
        console.log("No Data Found");
      }
      // this.spinner.stop();
    },
    error: (err) => {
      console.error("Error snapshotDetails:", err);
      this.spinner.stop();
    }
  });
}

  // pause(){
  //     if(this.text === 'Pause') {
  //       if(confirm("This action will pause migration process.Are you sure you want to continue?")){
  //       this.text = 'Resume'
  //       }
  //     } else {
  //       if(confirm("This action will resume migration process.Are you sure you want to continue?")){
  //       this.text = 'Pause'
  //       }
  //     }
  // }

  pauseProcess(){
    console.log("mgrid")
    console.log(this.mgrid)
    if(this.mgrid == undefined || this.mgrid == ''||this.mgrid == null) {
      this.snackbar.open("Migration is not in progress. Please start the migration.", "OK", {
        duration: 5000,
      });

    }else
    {
      var migrationselectedid = this.mgrid
      var caseextract = this.extractionCheckbox
      var globalextract=this.globalCheckbox
      var casetransform = this.transformationCheckbox

      // add for run o execute pre-transformation summary manually
      var casepreloadtransformation = this.preLoadTransformationCheckbox
      var caseload = this.loadCheckbox
      var casevalidation = this.validationCheckbox
      var attextract = this.attachextractCheckbox
      var attftpupload = this.ftpuploadCheckbox
      let obj = {
        "migrationId":migrationselectedid,
        "caseextract": caseextract,
        "casetransform": casetransform,
        "caseload": caseload,
        "casevalidation": casevalidation,
        "attextract": attextract,
        "attftpupload": attftpupload,
        "casePreloadSummary":casepreloadtransformation,
        "globalextract":globalextract
      }
      this.spinner.start()
      console.log(obj)
      this.service.insertJsuiteMigrationParent(obj).subscribe(response => {
        console.log(response);
        // checking if response is true or not
        if (response.error == true) {
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
          this.spinner.stop()
        } else {

          this.spinner.stop();
          console.log(response)
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });

        }
      })
    }
    this.spinner.stop()

  }

  abort(){
    if(confirm("This action will abort migration process.Are you sure you want to continue?")){
      this.spinner.start();
      console.log(this.migrationType);
      // in the below api call of abortmigration we have last parameter as 2 which is dummy and it is not useful but recommended to match the arguments size
      this.service.abortmigration(this.localStorageSettings.getSettings("dnsName"), this.migrationType,"Aborted",2).subscribe(res=>{
        console.log(res);
        if(res.error===true){
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          this.spinner.stop();
        }else{
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          this.spinner.stop();
          this.retrieveMigrationLog();
          this.MappingFile=''
        }
      })
    }
  }

  complete(){
    if(confirm("This action will complete migration process. Are you sure you want to continue?")){
      this.service.completemigration(this.localStorageSettings.getSettings("dnsName")).subscribe(res=>{
        console.log(res);
        if(res.error===true){
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }else{
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          this.retrieveMigrationLog();
        }
      })
    }
  }

  incrementalDataLoadSchedule() {
    this.dialog.open(IncrementalDataLoadSchedulePopupComponent, {
      width: "80%",
      autoFocus: false,
      data: { edata:{migrationid:this.migrationId,migrationType : this.migrationType },scheduleFor:'IncrementalDataLoad'},

      disableClose: true,

    });


  }
   /*-----------------------------------------------------------------------------------*/
   onGridReadymigration(params){
    this.gridmgrnAPI = params.api;
    this.temprunHistory = params;
    this.gridmgrnData=[];
    this.gridmgrnAPI.setGridOption('rowData', [])
    this.spinner.start();
    this.service.retrieveMigrationDatalog(this.localStorageSettings.getSettings("dnsName")).subscribe((val) => {
      
      console.log(val);
      this.gridmgrnData = val;
      if(this.gridmgrnData.length ===0){
        this.gridmgrnAPI.setGridOption('rowData', [])
      }else{
        this.tempdata=[];
        this.tempmgrndata=[];
        for(let i=0;i<this.gridmgrnData.length;i++){
          this.tempdata = this.gridmgrnData[i];
          this.tempmgrndata.push(this.tempdata);
        }
        console.log(this.tempmgrndata)
        this.gridmgrnAPI.setGridOption('rowData', this.tempmgrndata);
      }
    });
    this.spinner.stop();
  }

  loadData(){
    if(confirm("Are you sure you would like to start the data load to veeva vault? Click OK to proceed Or Cancel to ignore")){
      console.log(this.eachsetId)
      if(this.eachsetId.length === 0){
        this.snackbar.open("Please select atleast one Extraction Set", "Ok");
      }
      else{
        for(let i=0; i<=this.eachsetId.length; i++){
          console.log(this.eachsetId[i].activity);
          if(this.eachsetId[i].activity === "Extraction"){
            this.snackbar.open("Load Initiated", "Ok");
          }
          else{
            this.snackbar.open("Please select only Extraction set to Load.", "OK");
          }
        }
      }
    }
  }

  // For run history grid click
  cellClickedObjects(event){
    console.log(event)
    try{
    if(this.selectedGrid != 'old')
    {
      console.log(this.migrationTraceRadioSelection)
      this.flag = true;
      this.isDisabled = true;
      if (!event.colDef.cellRenderer) {
        this.migrationParentId = event.data.migrationId;
        this.migrationSelectedId = event.data.migrationId;
        this.spinner.start();
        this.migrationType=event.data.migrationType
        this.caseData(this.migrationTraceRadioSelection);
        this.gridDataValidation = [];
        this.gridAPIValidation.setGridOption('rowData', [])

    }
      
    }
    else{
    this.flag = true;
    this.isDisabled = true;
    console.log(event)
    console.log(event.colDef.cellRenderer)
    if (!event.colDef.cellRenderer) {
      this.migrationParentId = event.data.migrationId;
      this.migrationSelectedId = event.data.migrationId;
      this.spinner.start();
      this.migrationType=event.data.migrationType
      this.caseData(this.migrationTraceRadioSelection);
      this.gridDataValidation = [];
      this.gridAPIValidation.setGridOption('rowData', [])

    }
  }
 }catch(e){
  this.spinner.stop()
  console.log(e)
}
  }

 /**
  * @modified by Sai Naveen Somaraju
  * This method will active when we click on any row in the Second(migration current status grid)
  * Based on the activity of selected row it will set the activity in the third grid(object current status) and retrieve the data and put it into  Grid
  * @param e 
  * 
  */
  cellClickedSets(e) {
    this.isDisabledForObjectGrid=true;
    try {
      // for third grid variables
      this.loadActionForSelecetdSet=e.data.loadaction
      this.currentSetInMigrationGrid = e.data.setid
      this.currentActivityInMigrationGrid = e.data.activity
      this.currentMigrationIdInMigrationGrid = e.data.migrationid
      this.currentMigrationTraceIdInMigrationGrid = e.data.migrationtraceid
      this.currentActivityInObjectGrid=e.data.activity
      this.migrationTraceId=e.data.migrationtraceid
      this.currentActivityInObjectGrid=e.data.activity;
      /**purpose of makin != for validation when user 
      click on validation spinner and snack bar should not appear**/ 
      if(e.data.activity == "Validation"){
        e.data.activity = "Load"
        this.objectRadioValue="loadObjects"
        this.extractionInstrictionTrace=false
        this.attachmentLoadInstructionTrace=false
        this.loadInstructionTrace=true
        // Assigning the data to the GRID
        this.retrieveInstructionsBasedOnActivity(this.vaultvalidationAPI)
      }
      this.spinner.start();
       /**
       * This logic is to render the automaticaly the current process data in object grid
       */
      if (e.data.activity == "Extraction") {
        //for radio check boxes
        this.objectRadioValue="extractionObjects"
        // for grid actiavation
        this.extractionInstrictionTrace=true
        this.loadInstructionTrace=false
        this.attachmentLoadInstructionTrace=false

        // Assigning the data to the GRID
        this.retrieveInstructionsBasedOnActivity(this.vaultvalidationAPI)
      }
      else if (e.data.activity == "Transform") {
        ////selecting the Transform radio button
        this.objectRadioValue="transformObjects";


        this.extractionInstrictionTrace=true
        this.loadInstructionTrace=false
        this.attachmentLoadInstructionTrace=false
        // Assigning the data to the GRID
        this.retrieveInstructionsBasedOnActivity(this.vaultvalidationAPI)
      }
      else if (e.data.activity == "Load" ) {
        //selecting the load radio button
        this.objectRadioValue="loadObjects"
        
        this.extractionInstrictionTrace=false
        this.attachmentLoadInstructionTrace=false
        this.loadInstructionTrace=true
        // Assigning the data to the GRID
        this.retrieveInstructionsBasedOnActivity(this.vaultvalidationAPI)
      
      }
      else{
        this.isDisabledForObjectGrid=false;
      }
      this.spinner.stop();
    } catch (e) {
      console.log(e)
    }
    
  
  }




  // onRowSelected(event){
  //   console.log(event);
  //   console.log(event.node.selected);
  //   console.log(event.data.migrationid);
  //   console.log(event.data.setid);
  //   console.log(event.data.activity);
  //   this.migrationParentId = event.data.migrationid;
  //   this.setId = event.data.setid;
  //   this.activityLoad = event.data.activity;
  //   if(this.activityLoad === "Load"){
  //     if(event.node.selected === true)
  //     {
  //
  //           this.onGridReadyLoader(this.loaderAPI);
  //     }
  //
  //   }
  // }

  retrieveMigrationLog(){
    if(!this.spinnerStopping){
           this.spinner.start;
        }
    this.service.retrieveMigrationDatalog(this.localStorageSettings.getSettings("dnsName")).subscribe(response => {

      console.log(response)

      if (response.error == true) {

        this.snackbar.open(response.statusMessage, "Ok", { duration: 5000 });

        this.spinner.stop();

      }

      else {

        this.migrationDataLoadLogObject = response;

        console.log(this.migrationDataLoadLogObject);

        this.mgrstatus = "";
        this.mgrstartdt = "";
        this.mgrid = "";
        this.isAddSets=false;
        for(let i=0;i<this.migrationDataLoadLogObject.length;i++){
          if(this.migrationDataLoadLogObject[i].state === "In Progress"){
            if(this.migrationDataLoadLogObject[i].migrationType=="Data Migration"){
              this.isAddSets=true;
            }
            this.mgrstatus = this.migrationDataLoadLogObject[i].state;
            this.mgrstartdt = this.migrationDataLoadLogObject[i].startdt;
            this.mgrid = this.migrationDataLoadLogObject[i].migrationId;
            this.extractionCheckbox = this.migrationDataLoadLogObject[i].caseextract
            this.globalCheckbox=this.migrationDataLoadLogObject[i].globalextract
            this.attachextractCheckbox = this.migrationDataLoadLogObject[i].attextract
            this.ftpuploadCheckbox = this.migrationDataLoadLogObject[i].attftpupload
            this.loadCheckbox = this.migrationDataLoadLogObject[i].caseload
            this.transformationCheckbox = this.migrationDataLoadLogObject[i].casetransform
            this.validationCheckbox = this.migrationDataLoadLogObject[i].casevalidation
            this.preLoadTransformationCheckbox = this.migrationDataLoadLogObject[i].casepreloadsummary
            this.migrationType = this.migrationDataLoadLogObject[i].migrationType;

            console.log(this.migrationDataLoadLogObject);
          }
          if(this.mgrstatus != "In Progress"){
            this.mgrstatus = "Migration is not in progress";
          }

        }
        if(!this.spinnerStopping){
           this.spinner.stop();
        }
       

      }

    });
  }
  uploadFile(){
    console.log(this.statevaluechange.fileData)
    if (!this.FormValid.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.FormValid);

      this.validation.getvalidationmessage();
      return;

    }else{
      if(this.statevaluechange.fileData !== "")
      {
        if(this.MappingFile !==null || this.MappingFile !== "" || this.MappingFile !== undefined){
          // if(confirm("Are you sure you want to overwrite the existing file.")){
            this.spinner.start()
            this.statevaluechange.fileName="DM_Mappingfile.xlsx";
            let dnsName = this.localStorageSettings.getSettings("vaultDnsname");
            this.service.uploadMappingFile(this.statevaluechange,dnsName).subscribe(response =>{
              console.log(response);
              // checking if response is true or not
              if (response.error == true) {
                this.spinner.stop();
                this.snackbar.open(response.statusMessage, "OK", {
                  duration: 5000,
                });

              } else {
                // this.spinner.stop();
                console.log(response)
                this.snackbar.open(response.statusMessage, "OK", {
                  duration: 5000,
                });
                 this.retriveMappingFile();
              }
              this.cancel();
              // this.spinner.stop();
            });
          // }else{

          //   this.cancel();
          // }
          this.FormValid.reset();
        }
      }else{
        this.snackbar.open("Please select the Excel file", "OK", {
          duration: 5000,
        });
      }

    }
  }

  cancel(){
    this.statevaluechange.fileData="";
    this.statevaluechange.fileName="";
    this.FormValid.reset();
    this.formvalidations();
    this.FormValid.clearValidators();
  }

  //pagination code for Run History grid
  onRunPaginationChanged() {
    if (this.gridmgrnAPI) {
      this.RunlastPage = this.gridmgrnAPI.paginationIsLastPageFound();
      this.RuncurrentPage = this.gridmgrnAPI.paginationGetCurrentPage() + 1
      this.RunnextPage = this.gridmgrnAPI.paginationGetCurrentPage() + 1 + 1
      this.RunnextPagePlusOne = this.gridmgrnAPI.paginationGetCurrentPage() + 1 + 1 + 1
      this.RuntotalPages = this.gridmgrnAPI.paginationGetTotalPages()
    }
  }

  //this function is for going to the given page number
  onRunSearchChange(searchValue: number) {
    this.gridmgrnAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onRunPageSizeChanged(newPageSize) {
    console.log(this.RunpageSize)
    var value = this.RunpageSize;
    this.gridmgrnAPI.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onRunBtNext() {
    console.log("next")
    this.gridmgrnAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onRunBtPrevious() {
    console.log("previous")
    this.gridmgrnAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onRunBtFirst() {
    this.gridmgrnAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onRunBtLast() {
    this.gridmgrnAPI.paginationGoToLastPage();
  }
  //pagination code ends


  //pagination code
  onPaginationChanged() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridAPI.paginationGetTotalPages()
    }
  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    console.log(this.pageSize)
    var value = this.pageSize;
    this.gridAPI.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }
  //pagination code ends

  //pagination code for load grid
  onloadPaginationChanged() {
    if (this.gridAPIValidation) {
      this.loadlastPage = this.gridAPIValidation.paginationIsLastPageFound();
      this.loadcurrentPage = this.gridAPIValidation.paginationGetCurrentPage() + 1
      this.loadnextPage = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1
      this.loadnextPagePlusOne = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1 + 1
      this.loadtotalPages = this.gridAPIValidation.paginationGetTotalPages()
    }
  }

  //this function is for going to the given page number
  onloadSearchChange(searchValue: number) {
    this.gridAPIValidation.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onloadPageSizeChanged(newPageSize) {
    var value = this.loadpageSize;
    this.gridAPIValidation.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onloadBtNext() {
    console.log("next")
    this.gridAPIValidation.paginationGoToNextPage();
  }

  // below function for going to previous page
  onloadBtPrevious() {
    console.log("previous")
    this.gridAPIValidation.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onloadBtFirst() {
    this.gridAPIValidation.paginationGoToFirstPage();
  }

  // below function for going to last page
  onloadBtLast() {
    this.gridAPIValidation.paginationGoToLastPage();
  }
  //pagination code for load grid ends



  // below function is to load the ag grid
  onGridReadyCaseData(params: any): void {
    console.log(this.migrationType);
    this.flag = true;
    this.migrationTrace = true;
    this.transformTrace = false;
    this.globaltrace = false;
    this.gridData = [];
    this.tempextractparams = params;
    console.log("params",params)
    console.log(params.api)
    this.gridAPI = params.api;
    this.gridColumnAPI = params.api;
     console.log(this.selectedGrid)
    if (this.selectedGrid === 'old' && this.gridColumnAPI) {
      let hidefields = ["startdt", "enddt"];
      // hidefields.forEach(colId => {
      //   this.gridColumnAPI.setColumnsVisible(colId, false);
      // });
      this.gridColumnAPI.setColumnsVisible(hidefields, false);
    }else{
      let hidefields = ["extractstartdt","extractionenddt","tranformationstartdt", "transformationenddt","loadstartdt","loadenddt"];
      // hidefields.forEach(colId => {
      //   this.gridColumnAPI.setColumnsVisible(colId, false);
      // });
      this.gridColumnAPI.setColumnsVisible(hidefields, false);
    }
    this.gridAPI.setGridOption('rowData', []);
    this.spinner.start();
    console.log(this.migrationType);
    console.log(this.localStorageSettings.getSettings("dnsName"), this.migrationParentId, this.migrationType);
  
    if (
      this.localStorageSettings.getSettings("dnsName") &&
      this.migrationParentId !== null &&
      this.migrationType !== null &&
      typeof this.migrationParentId !== "undefined" &&
      typeof this.migrationType !== "undefined"
    ) {
      /**
         * @author Chandra R
         * @Date 20-01-2025
         * @Desc code changes for adding new grid in migration screen
         */
      if (this.selectedGrid === 'old') {
        this.service
          .retrieveMigrationExtracttrace(this.localStorageSettings.getSettings("dnsName"), this.migrationParentId, "ETL")
          .subscribe(
            (val) => {
              console.log(val);
              this.gridData = val || [];
              if (this.gridData.length === 0) {
                this.gridAPI.setGridOption('rowData', []);
              } else {
                this.extractionData = this.gridData.map((item) => {
                  // Add migrationType field
                  item.migrationType = this.migrationType;
  
                  // Add isSetIdIsNegativeFloat and isStateDeleted fields
                  //item.isSetIdIsNegativeFloat = parseFloat(item.setid) < 0 || parseFloat(item.setid) % 1 !== 0;
                  item.isStateDeleted = item.state === 'Deleted';
  
                  // Add runInstance and setName if migrationId matches parentId
                  if (item.migrationid === this.migrationParentId) {
                    item.setName = item.setid;
                    item.runInstance = `Run_${item.migrationid}`;
                  }

                  return item;
                });
  
                console.log(this.extractionData);
                this.gridAPI.setGridOption('rowData', this.extractionData);
              }
              this.spinner.stop();
            },
            (error) => {
              console.error("Error fetching migration extract trace:", error);
              this.spinner.stop();
            }
          );
      } else {
        this.service.retriveSetDetails(this.localStorageSettings.getSettings("dnsName"),this.migrationParentId,"ETL").subscribe((val) => {
          console.log(val);
          this.gridData = val || [];
          if (this.gridData.length === 0) {
            this.gridAPI.setGridOption('rowData', []);
          } else {
            this.extractionData = this.gridData.map((item) => {
              // Add migrationType field
              item.migrationType = this.migrationType;

              // Add isSetIdIsNegativeFloat and isStateDeleted fields
              //item.isSetIdIsNegativeFloat = parseFloat(item.setid) < 0 || parseFloat(item.setid) % 1 !== 0;
              item.isStateDeleted = item.state === 'Deleted';

              // Add runInstance and setName if migrationId matches parentId
              if (item.migrationid === this.migrationParentId) {
                item.setName = item.setid;
                item.runInstance = `Run_${item.migrationid}`;
              }

              return item;
            });

          /**
           *@Modified By Rahul vk 
           *@jiraId 4815
           *@date :- 28/05/25      
           *@desc Added this Filter to filter Entire Extraction Data 
           *      To Avoid Attachment Activity to be set in ObjectData Grid
           * 
           */  
      
      //  Inline activity filtering here (skip Attachment* activity types)
        const filtered = this.extractionData.filter(item =>
          item.activity !== 'AttachmentLoadToFTP' &&
          item.activity !== 'AttachmentExtraction' &&
          item.activity !== 'AuditTrailExtraction'  //Added By Shantanu Ghate
        );

        this.gridAPI.setGridOption('rowData', filtered);
            
          }
          this.spinner.stop();
        },
        (error) => {
          console.error("Error fetching migration extract trace:", error);
          this.spinner.stop();
        }
      );
      }
    } else {
      console.warn("Missing required parameters: dnsName, migrationParentId, or migrationType.");
      this.spinner.stop();
    }
  }



  
  
  onGridReadyAttachmentsData(params){
    // assigning the variables
    this.migrationTrace=false;
    this.transformTrace=true;
    this.globaltrace=false;
    this.transformApi = params;
    this.gridAPI = params.api;
    this.gridColumnAPI = params.api;
    this.gridattachmentData=[];
    this.gridAPI.setGridOption('rowData', [])
    this.spinner.start();
    // this.migrationType="ETL_Attachments";
    console.log(this.migrationType);

    console.log(this.localStorageSettings.getSettings("dnsName"),this.migrationParentId,this.migrationType)
    if (
      this.localStorageSettings.getSettings("dnsName") &&
      this.migrationParentId !== null &&
      this.migrationType !== null &&
      typeof this.migrationParentId !== "undefined" &&
      typeof this.migrationType !== "undefined"
    ){
      /**
         * @author Chandra R
         * @Date 20-01-2025
         * @Desc code changes for adding new grid in migration screen
      * */
      if(this.selectedGrid == 'old'){
      this.service.retrieveMigrationExtracttrace(this.localStorageSettings.getSettings("dnsName"),this.migrationParentId,"ETL_Attachments").subscribe((val) => {
      console.log(val)
      this.gridattachmentData = val;
      if(this.gridattachmentData.length ===0){
        this.gridAPI.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
        this.temptrnsdata=[];
        this.transformData=[];
        this.currentMigrationTraceIdInMigrationGrid=this.gridattachmentData[0].migrationtraceid
        for(let i=0;i<this.gridattachmentData.length;i++){
          //  if(this.gridattachmentData[i].activity ==="Transform"){
          console.log(this.migrationParentId+ "1");
          // if (parseFloat(this.gridattachmentData[i].setid) < 0 || parseFloat(this.gridattachmentData[i].setid) % 1 != 0){
          //   this.gridattachmentData[i]['isSetIdIsNegativeFloat'] = true;
          // } else{
          //   this.gridattachmentData[i]['isSetIdIsNegativeFloat'] = false;
          // }
       //   if(this.gridattachmentData[0].activity=)
          if(this.gridattachmentData[i].migrationid == this.migrationParentId){
            this.gridattachmentData[i].setName = this.gridattachmentData[i].setid;
            this.gridattachmentData[i].runInstance = "Run_"+this.gridattachmentData[i].migrationid
            this.temptrnsdata = this.gridattachmentData[i];
            this.transformData.push(this.temptrnsdata);
          }
          //  }
        }
        console.log("data docattach")
        console.log(this.transformData)
        this.gridAPI.setGridOption('rowData', this.transformData)

if (this.gridColumnAPI) {
  const availableFields = this.gridColumnAPI.getColumns().map(c => c.getColDef().field);

  if (this.selectedGrid === 'old') {
    const hidefieldsForoldAttachment: string[] = [];
    ['startdt', 'enddt'].forEach(col => {
      if (availableFields.includes(col)) {
        // this.gridColumnAPI.setColumnVisible(col, false);
        hidefieldsForoldAttachment.push(col);
      }
    });
    if (hidefieldsForoldAttachment.length > 0) {
      this.gridColumnAPI.setColumnsVisible(hidefieldsForoldAttachment, false);
    }
  }

  if (this.selectedGrid === 'new') {
    const hidefieldsForNewAttachment : string[] = [];
    ['attachmentstartdate', 'attachmentenddt', 'ftpstartdt', 'ftpenddt'].forEach(col => {
      if (availableFields.includes(col)) {
        // this.gridColumnAPI.setColumnVisible(col, false);
        hidefieldsForNewAttachment.push(col); 
      }
    });
    if (hidefieldsForNewAttachment.length > 0) {
      this.gridColumnAPI.setColumnsVisible(hidefieldsForNewAttachment, false);
    }
  }
}

        this.spinner.stop();
      }
      });
     }
    
  else{
    this.service.retriveSetDetails(this.localStorageSettings.getSettings("dnsName"),this.migrationParentId,"ETL").subscribe((val) => {
      console.log(val)
      this.gridattachmentData = val;
      if(this.gridattachmentData.length ===0){
        this.gridAPI.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
        this.temptrnsdata=[];
        this.transformData=[];
        this.currentMigrationTraceIdInMigrationGrid=this.gridattachmentData[0].migrationtraceid
        for(let i=0;i<this.gridattachmentData.length;i++){
          //  if(this.gridattachmentData[i].activity ==="Transform"){
          console.log(this.migrationParentId+ "1");
          // if (parseFloat(this.gridattachmentData[i].setid) < 0 || parseFloat(this.gridattachmentData[i].setid) % 1 != 0){
          //   this.gridattachmentData[i]['isSetIdIsNegativeFloat'] = true;
          // } else{
          //   this.gridattachmentData[i]['isSetIdIsNegativeFloat'] = false;
          // }
       //   if(this.gridattachmentData[0].activity=)
          if(this.gridattachmentData[i].migrationid == this.migrationParentId){
            this.gridattachmentData[i].setName = this.gridattachmentData[i].setid;
            this.gridattachmentData[i].runInstance = "Run_"+this.gridattachmentData[i].migrationid
            this.temptrnsdata = this.gridattachmentData[i];
            this.transformData.push(this.temptrnsdata);
          }
          //  }
        }
        console.log("data docattach")
        /**
           *@Modified By Rahul vk 
           *@jiraId 4815
           *@date :- 28/05/25      
           *@desc Added this Filter to filter Entire transformData 
           *      To Avoid ETLV Activity to be set in Documnent Attachment Grid
           * 
           */  
      //  Inline activity filtering here (skip Attachment* activity types)
        //Only include AttachmentLoadToFTP and AttachmentExtraction
        const filteredAcivityForAttachemnt = this.transformData.filter(item =>
          item.activity === 'AttachmentLoadToFTP' ||
          item.activity === 'AttachmentExtraction' ||
          item.activity === 'AuditTrailExtraction'  // Added By Shantanu Ghate
        );

        this.gridAPI.setGridOption('rowData', filteredAcivityForAttachemnt);		

if (this.gridColumnAPI) {
  const availableFields = this.gridColumnAPI.getColumns().map(c => c.getColDef().field);

  if (this.selectedGrid === 'old') {
    const hidefieldsForoldAttachment: string[] = [];
    ['startdt', 'enddt'].forEach(col => {
      if (availableFields.includes(col)) {
        hidefieldsForoldAttachment.push(col);
      }
    });
    if (hidefieldsForoldAttachment.length > 0) {
      this.gridColumnAPI.setColumnsVisible(hidefieldsForoldAttachment, false);
    }
  }

  if (this.selectedGrid === 'new') {
    const hidefieldsForNewAttachment: string[] = [];
    ['attachmentstartdate', 'attachmentenddt', 'ftpstartdt', 'ftpenddt'].forEach(col => {
      if (availableFields.includes(col)) {
        // this.gridColumnAPI.setColumnVisible(col, false);
        hidefieldsForNewAttachment.push(col);
      }
    });
    if (hidefieldsForNewAttachment.length > 0) {
      this.gridColumnAPI.setColumnsVisible(hidefieldsForNewAttachment, false);
    }
  }
}

        this.spinner.stop();
      }
    });
    }
    }
  }

  onGridReadyLoader(params){
    this.vaultvalidationAPI = params;
    this.gridLoaderAPI = params.api;
    this.gridLoadData=[];
    this.gridLoaderAPI.setGridOption('rowData', []);
    this.loadsetId=[];
    this.spinner.start();
    this.service.retrieveLoaderExtractTrace(this.localStorageSettings.getSettings("dnsName")).subscribe((val) => {
      console.log(val)
      this.loadsetId = val;
      if(this.loadsetId.length ===0)
      {
        this.gridLoaderAPI.setGridOption('rowData', [])
      }
      else
      {
        this.temploaddata=[];
        //this.loaderData=[];
        for(let i=0;i<this.loadsetId.length;i++)
        {
          if(this.loadsetId[i].migrationid == this.migrationParentId  && this.loadsetId[i].setid == this.setId)
          {
            this.loadsetId[i].setName = "SET"+this.loadsetId[i].setid;
            this.loadsetId[i].runInstance = "Run_"+this.loadsetId[i].migrationid;
            this.temploaddata = this.loadsetId[i];
            this.loaderData.push(this.temploaddata)
          }
        }
        console.log(this.loaderData);
        this.gridLoaderAPI.setGridOption('rowData', this.loaderData)
      }
    });
    this.spinner.stop();
  }

  selectedmigrationid(migrationdata){
    console.log(migrationdata)
    console.log(migrationdata.rowData.activity)
    this.loadingActivity = migrationdata.rowData.activity;
    if(this.loadingActivity === "Load" || this.loadingActivity === "Validation")
    {
      console.log(migrationdata)
      if(migrationdata.event.checked===true){
        let checkvaultvalidation={
          "setName":migrationdata.rowData.setid,
          "migrationid":migrationdata.rowData.migrationid
        }
        console.log(checkvaultvalidation)
        this.loadsetId.push(checkvaultvalidation);
        if(this.loadsetId.length===0){
          this.validationreport=false;
        }else{
          this.validationreport=true;
          this.bindvaultvalidationreport(this.loadsetId);
        }
      }else{
        this.loadsetId.forEach(eachvaultvalidation=>{
          if(eachvaultvalidation.setName===migrationdata.rowData.setid){
            let setid = this.loadsetId.indexOf(eachvaultvalidation)
            this.loadsetId.splice(setid,1)
            console.log(this.loadsetId)
            this.bindvaultvalidationreport(this.loadsetId);
          }
        })
      }
    }
  }

  // selectedmigrationid(migrationdata){
  //   console.log(migrationdata)
  //   console.log(migrationdata.rowData.activity)
  //   this.loadingActivity = migrationdata.rowData.activity;
  //   if(this.loadingActivity==="Transform"){
  //     console.log(migrationdata.rowData.setid)
  //     if(this.transformsetid===""){
  //     this.transformsetid = migrationdata.rowData.setid;
  //     }else{
  //       this.transformsetid =this.transformsetid+","+migrationdata.rowData.setid;
  //     }
  //     console.log(this.transformsetid)
  //   }
  //   if(this.loadingProcess==="Extraction"){
  //     if(migrationdata.event.checked===true){
  //       let setid = {
  //         "setId": migrationdata.rowData.setid,
  //         "activity":migrationdata.rowData.activity
  //       }
  //       console.log(setid)
  //       this.eachsetId.push(setid);
  //     }else{
  //       this.eachsetId.forEach(eachextract=>{
  //         console.log(eachextract)
  //         if(eachextract.setId === migrationdata.rowData.setid){
  //           let extractsetid = this.eachsetId.indexOf(eachextract);
  //           this.eachsetId.splice(extractsetid,1)
  //         }
  //       })
  //     }
  //     console.log(this.eachsetId)
  //   }
  //   if(this.loadingActivity === "Load")
  //   {
  //     console.log(migrationdata)
  //     if(migrationdata.event.checked===true){
  //       let checkvaultvalidation={
  //         "setName":migrationdata.rowData.setid,
  //         "migrationid":migrationdata.rowData.migrationid
  //       }
  //       console.log(checkvaultvalidation)
  //       this.loadsetId.push(checkvaultvalidation);
  //       if(this.loadsetId.length===0){
  //         this.validationreport=false;
  //       }else{
  //         this.validationreport=true;
  //       this.bindvaultvalidationreport(this.loadsetId);
  //     }
  //     }else{
  //       this.loadsetId.forEach(eachvaultvalidation=>{
  //         if(eachvaultvalidation.setName===migrationdata.rowData.setid){
  //         let setid = this.loadsetId.indexOf(eachvaultvalidation)
  //         this.loadsetId.splice(setid,1)
  //         console.log(this.loadsetId)
  //         this.bindvaultvalidationreport(this.loadsetId);
  //         }
  //       })
  //     }
  //   }
  // }

  bindvaultvalidationreport(eachsetdata){
    console.log(eachsetdata)
    this.setvalidationdata=[];
    this.onGridReadyVaultValidationRefresh(this.vaultvalidationAPI,eachsetdata);
  }

  onGridReadyVaultValidationRefresh(vaultrefresh,selectedload){
    this.vaultvalidationAPI = vaultrefresh;
    this.gridAPIValidation = vaultrefresh.api;
    this.gridDataValidation=[];
    // this.gridAPIValidation.setGridOption('rowData', [])
    this.spinner.start();
    this.service.retrieveVaultInstruction(this.migrationTraceId).subscribe((val) => {
      console.log(val)
      this.gridDataValidation = val;
      if(this.gridDataValidation.length ===0){
        //this.gridAPIValidation.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
        this.temploaddataValidation=[];
        this.vaultValidationData=[];
        for(let i=0;i<this.gridDataValidation.length;i++){
          this.gridDataValidation[i].setName = this.gridDataValidation[i].setid;
          this.gridDataValidation[i].runInstance = "Run_"+this.gridDataValidation[i].migrationid;
          this.temploaddataValidation = this.gridDataValidation[i];
          console.log(this.temploaddataValidation);
          this.vaultValidationData.push(this.temploaddataValidation);
        }
        console.log(this.vaultValidationData)
        console.log(selectedload)
        this.setvalidationdata=[];
        this.gridDataValidation.forEach(element => {
          selectedload.forEach(eachset => {
            if(eachset.setName === element.setid && eachset.migrationid === element.migrationid){
              console.log(element)
              console.log(eachset.setid+"  "+ eachset.migrationid)
              let elementdata = element;
              this.setvalidationdata.push(elementdata);
            }
          });
        });
        console.log(this.setvalidationdata)
        this.gridAPIValidation.setGridOption('rowData', this.setvalidationdata)
        this.spinner.stop();
      }
    });
  }
  /**
   * Retrieve the load prepared instruction only if migrationtrace id is available
   * @param params 
   */
  onGridReadyVaultValidation(params){
    this.vaultvalidationAPI = params;
    this.gridAPIValidation = params.api;
    this.gridDataValidation=[];
    this.gridAPIValidation.setGridOption('rowData', [])
    console.log(this.migrationTraceId);
    this.spinner.start();
    if(this.currentMigrationTraceIdInMigrationGrid!=undefined){
    this.service.retrieveVaultInstruction(this.currentMigrationTraceIdInMigrationGrid).subscribe((val) => {
      console.log(val)
      this.gridDataValidation = val;
      if(this.gridDataValidation.length ===0){
        this.gridAPIValidation.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
        this.temploaddataValidation=[];
        this.vaultValidationData=[];
        let parentDeleted;
        console.log(this.gridData[0].migrationtraceid)
        for(let i =0; i< this.gridData.length; i++){
          console.log(this.gridData[i].migrationtraceid === this.migrationTraceId)
          if(this.gridData[i].migrationtraceid === this.migrationTraceId){
            if (this.gridData[i].state === 'Deleted'){
              parentDeleted = true;
            }
          }
        }
        for(let i=0;i<this.gridDataValidation.length;i++){
          console.log(this.gridDataValidation[i].loadAction === 'delete')
            //added one more condition to check the set laodaction not only instruction load action
          if ((this.gridDataValidation[i].loadAction === 'delete' || parentDeleted) && this.loadActionForSelecetdSet==='delete'){
             this.gridDataValidation[i]['isLoadActionDelete'] = true;
          } else{
            this.gridDataValidation[i]['isLoadActionDelete'] = false;
          }
          // if(this.gridDataValidation[i].setid == this.parentSetId && this.gridDataValidation[i].migrationid == this.migrationParentId){
          this.gridDataValidation[i].setName = this.gridDataValidation[i].setid;
          this.gridDataValidation[i].runInstance = "Run_"+this.gridDataValidation[i].migrationid
          this.temploaddataValidation = this.gridDataValidation[i];
          this.vaultValidationData.push(this.temploaddataValidation);
          // }
        }
        console.log(this.vaultValidationData)
        this.gridAPIValidation.setGridOption('rowData', this.vaultValidationData)
        this.spinner.stop();
      }
    });}
  }


  selectedprocess(e){
    // this.loadingProcess="";
    // console.log(e)
    // this.loadingProcess = e;
    // if(this.loadingProcess==="Transform" || this.loadingProcess==="Extraction"){
    //   // this.onGridReadyAttachmentsData(this.transformApi)
    //   this.onGridReadyCaseData(this.tempextractparams)
    // // }else if(this.loadingProcess ==="Extraction"){
    // // this.onGridReadyCaseData(this.tempextractparams)
    // }else if(this.loadingProcess ==="Load"){
    //   this.onGridReadyLoader(this.loaderAPI)
    // }
  }

  onTransformation()
  {
    if(this.eachsetId.length===0){
      return this.snackbar.open("Please select Extract to Transform", "OK", { duration: 5000 });
    }else{
      this.data={
        "dnsId":this.localStorageSettings.getSettings("dnsName"),
        "userId":this.localStorageSettings.getSettings("UserId"),
        "dnsName":this.localStorageSettings.getSettings("vaultDnsname"),
        "setId":this.eachsetId
      }
      this.spinner.start();
      console.log(this.data)
      this.service.transformMigration(this.data).subscribe(res=>{
        console.log(res);
        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      })
      this.spinner.stop();
    }

  }
  onLoading(){
    if(this.transformsetid===undefined || this.transformsetid===null || this.transformsetid===""){
      return this.snackbar.open("Please select Transformation to Load", "OK", { duration: 5000 });
    }
    else{
      this.data={
        "dnsId":this.localStorageSettings.getSettings("dnsName"),
        "userId":this.localStorageSettings.getSettings("UserId"),
        "dnsName":this.localStorageSettings.getSettings("vaultDnsname")
      }
      this.spinner.start();
      // this.migrationType="ETL";
      this.service.loadToVault(this.data.dnsName,this.data.dnsId,this.transformsetid,this.migrationType).subscribe(res=>{
        console.log(res);
        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        this.transformsetid="";
      })
      this.spinner.stop();
    }

  }
  // onExtration(){
  //   this.service.retrieve().subscribe(res=>{
  //     console.log(res);
  //     this.service.downloadFile(res, 'jsontocsv');

  //   })
  // }


  retriveMappingFile(){
    this.MappingFile="";
    this.spinner.start();
    this.service.retriveMappingFile(this.localStorageSettings.getSettings("dnsName")).subscribe(res=>{
      console.log(res.mappingfile);
      if(res === "" || res === undefined || res === null){
        this.spinner.stop()
        //this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      }else if(res.mappingfile === "object not found"){
        this.spinner.stop()
      }
      else{
        this.MappingFile=res.mappingfile.split('.').slice(0,-1).join('.');
        console.log(this.MappingFile)
        this.spinner.stop()
        //this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      }
    })
    // this.spinner.stop();
  }


  downloadmappingfile(){

    if(this.buttonIdList.includes(118)){
    let migrationId = this.mgrid
    if(this.mgrid == undefined || this.mgrid == ''||this.mgrid == null) {
      this.snackbar.open("Migration is not in progress. Please start the migration.", "OK", {
        duration: 5000,
      });

    }else {

    this.snackbar.open("Download is underway. Please do not click again the download until it completes the download.", "OK", {duration: 10000});
      this.service.downloadMappingFile(migrationId).subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should

        console.log(x)
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        if (responseData) {
          this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        } else {
          console.log(x)
          var newBlob = new Blob([x]);
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = "DM_Mappingfile_" + migrationId + ".xlsx";
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

          this.snackbar.open("Download Completed", "OK", {duration: 5000});
        }
      })
    }
  }
  else{
    this.snackbar.open(this.constants.Mappingfile, "OK", {duration: 5000});
   }
  }

  MappingFileDoc
  downloadMappingfileLocal(){
    this.spinner.start();
    this.snackbar.open("Download is underway. Please do not click again the download until it completes the download.", "OK", {duration: 10000});
    this.service.download_test(this.restApi.downloadFileUrl+"/"+"mapping/")
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x]);

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);

        var link = document.createElement('a');
        link.href = data;
        link.download = "DM_Mappingfile.xlsx";
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      });
      this.snackbar.open("Download Completed", "OK", {duration: 5000});
    this.spinner.stop();

  }

  verificationreport(){

  }
  // downloadmappingfileExtract(e){
  //   console.log(e.rowData)
  //   console.log(e.activity)
  //   this.spinner.start();
  //     this.service.downloadExtractFile(this.localStorageSettings.getSettings("dnsName"),e.rowData.logfilepath).subscribe(res=>{
  //       console.log(res);
  //       if(res.error===true){

  //         this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
  //       }else{
  //         this.downloadExtractFileLocal(e.rowData.logfilepath);
  //         this.spinner.stop();
  //         this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
  //       }
  //     })

  // }

  downloadmappingfileExtract(e){
    this.dFlage = false
    console.log(this.restrictDownloadFlage);
    console.log(this.restApi.DOWNLOADSOURCEFILE+"/"+this.localStorageSettings.getSettings("AuthUsername")+"/"+this.localStorageSettings.getSettings("vaultDnsname")+"/"+e.activity+"/"+e.rowData.migrationid+"/"+e.rowData.setid)
    //added condition to restrict multi download when download inprogress
    if(this.restrictDownloadFlage){
      this.restrictDownloadFlage=false;
      console.log(this.restrictDownloadFlage);
      let dnsid = localStorage.getItem("dnsName");
    this.service.retrieveJsuiteProperty(dnsid, "S3_Download_DataSize").subscribe(res=>{
      console.log("Test string");
      console.log(res)
      this.s3DataSize = res;
      console.log(this.s3DataSize);
      console.log(this.s3DataSize.propertyvalue);
    });
    this.spinner.start();
    this.snackbar.open("Download is underway. Please do not click again the download until it completes the download.", "OK", {duration: 10000});
    this.service.download_zip(this.restApi.DOWNLOADSOURCEFILE+"/"+this.localStorageSettings.getSettings("AuthUsername")+"/"+this.localStorageSettings.getSettings("vaultDnsname")+"/"+e.activity+"/"+e.rowData.migrationid+"/"+e.rowData.setid)
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x],{type:'application/zip'});
        console.log(newBlob.size)
        var sizeInMB = newBlob.size / (1024 * 1024); // Convert to MB
        console.log("Size in MB:", sizeInMB);


        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        if(newBlob.size==0){
          this.spinner.stop();
          this.snackbar.open("Download failed. Please try again after some time.", "OK", {
            panelClass: 'snack'
        });
        this.restrictDownloadFlage=true;
          return;
        }else if(sizeInMB > this.s3DataSize.propertyvalue){
          this.spinner.stop();
          this.snackbar.open("Download failed. The data size exceeds "+this.s3DataSize.propertyvalue+" MB and cannot be downloaded from S3", "OK", {
            duration: 10000
                  });
        this.restrictDownloadFlage=true;
          return;

        }
        const data = window.URL.createObjectURL(newBlob);
        console.log(data)
        var link = document.createElement('a');
        link.href = data;
        console.log(e.rowData.fileName)
        link.download = e.rowData.setid+"_"+e.activity+".zip";
        console.log("ento")
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
        this.snackbar.open("Download Completed", "OK", {duration: 5000});
        this.restrictDownloadFlage=true;
        this.spinner.stop();
      });
      this.spinner.stop();
    }else{
      console.log("restrict to download when download is inprogress")
      console.log(this.restrictDownloadFlage);
      this.snackbar.open("Download is underway. Please do not click again the download until it completes the download.", "OK", {duration: 10000});
    }
  }

  downloadAttachmentLogs(e){
    this.dFlage = false;
    console.log(this.restApi.DOWNLOADSOURCEFILE+"/"+this.localStorageSettings.getSettings("AuthUsername")+"/"+this.localStorageSettings.getSettings("vaultDnsname")+"/"+e.rowData.activity+"/"+e.rowData.migrationid+"/"+e.rowData.setid)
    if(this.restrictDownloadFlage){
      this.restrictDownloadFlage=false;
      console.log(this.restrictDownloadFlage);
    this.spinner.start();
    this.snackbar.open("Download is underway. Please do not click again the download until it completes the download.", "OK", {duration: 10000});
    let dnsid = localStorage.getItem("dnsName");
    this.service.retrieveJsuiteProperty(dnsid, "S3_Download_DataSize").subscribe(res=>{
      console.log("Test string");
      console.log(res)
      this.s3DataSize = res;
      console.log(this.s3DataSize);
      console.log(this.s3DataSize.propertyvalue);
    });
    this.service.download_zip(this.restApi.DOWNLOADSOURCEFILE+"/"+this.localStorageSettings.getSettings("AuthUsername")+"/"+this.localStorageSettings.getSettings("vaultDnsname")+"/"+e.rowData.activity+"/"+e.rowData.migrationid+"/"+e.rowData.setid)
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x],{type:'application/zip'});
        console.log(newBlob.size)
        var sizeInMB = newBlob.size / (1024 * 1024); // Convert to MB
        console.log("Size in MB:", sizeInMB);

        if(sizeInMB > this.s3DataSize.propertyvalue){
          console.log("data size")
          this.spinner.stop();
          this.snackbar.open("Download failed. The data size exceeds "+this.s3DataSize.propertyvalue+" MB and cannot be downloaded from S3", "OK", {
            duration: 10000
         });
        this.restrictDownloadFlage=true;
        return;
        }

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        console.log(data)
        var link = document.createElement('a');
        link.href = data;
        console.log(e.rowData.fileName)
        link.download = e.rowData.setid+"_"+e.rowData.activity+".zip";
        console.log("ento")
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
        this.snackbar.open("Download Completed", "OK", {duration: 5000});
        this.restrictDownloadFlage=true;
        this.spinner.stop();
      });
    this.spinner.stop();
  }else{
    console.log("restrict to download when download is inprogress")
    console.log(this.restrictDownloadFlage);
    this.snackbar.open("Download is underway. Please do not click again the download until it completes the download.", "OK", {duration: 10000});
  }
  }


  zipDoc
  zipdownload(e) {
    console.log(e.rowData)
    this.zipDoc = e.rowData.logfilepath
    this.spinner.start();
    this.service.download_zip(this.zipDoc)
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x],{type:'application/zip'});

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        console.log(data)
        var link = document.createElement('a');
        link.href = data;
        console.log(e.rowData.fileName)
        link.download = e.rowData.setName+".zip";
        console.log("ento")
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      });
    this.spinner.stop();

  }

  Doc
  docdownload(e) {
    console.log(e.rowData)
    this.Doc = e.rowData.logfilepath
    if(this.Doc===undefined || this.Doc=== "" || this.Doc ===null){
      this.snackbar.open("Please Wait till the process is completed.", "OK", {
        panelClass: 'snack'
      });
    }else{
      this.spinner.start();
      this.service.download_test(this.Doc)
        .subscribe(x => {
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([x]);

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);

          var link = document.createElement('a');
          link.href = data;
          link.download = e.rowData.fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);
        });
      this.spinner.stop();
    }
  }

  successDoc
  docdownloadSuccess(e){
    console.log(e.rowData)
    this.successDoc = e.rowData.CSVdownloadpath_success
    if(this.successDoc===undefined || this.successDoc=== "" || this.successDoc ===null){
      this.snackbar.open("Please Wait till the process is completed.", "OK", {
        panelClass: 'snack'
      });
    }else{
      this.spinner.start();
      this.service.download_test(this.successDoc+"/"+this.localStorageSettings.getSettings("vaultDnsname")+"/success/failure")
        .subscribe(x => {
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([x]);

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);

          var link = document.createElement('a');
          link.href = data;
          // downloading success log file with filename.csv instead of objectname.csv
          link.download = e.rowData.fileName+".csv";
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);
        });
      this.spinner.stop();
    }
  }

  failureDoc
  docdownloadFailure(e){
    console.log(e.rowData)
    this.failureDoc = e.rowData.CSVdownloadpath_failure
    if(this.failureDoc===undefined || this.failureDoc=== "" || this.failureDoc ===null){
      this.snackbar.open("Please Wait till the process is completed.", "OK", {
        panelClass: 'snack'
      });
    }else{
      this.spinner.start();
      this.service.download_test(this.failureDoc+"/"+this.localStorageSettings.getSettings("vaultDnsname")+"/success/failure")
        .subscribe(x => {
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([x]);

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }


          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);

          var link = document.createElement('a');
          link.href = data;
          // downloading failure log file with filename.csv instead of objectname.csv
          link.download = e.rowData.fileName+".csv";
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);
        });
      this.spinner.stop();
    }
  }

  downloadQLfileLOader(e){
    this.dFlage = false;
    console.log(e)
    // if(e.rowData.validationreportpath==="" || e.rowData.validationreportpath === null || e.rowData.validationreportpath === undefined){
    //   this.snackbar.open("No File to Download","OK", { duration: 5000 });
    // }else{
    this.spinner.start();
    this.service.downloadValidationReportFile(this.localStorageSettings.getSettings("dnsName"),e.rowData.migrationtraceid+"/"+"QL").subscribe(res=>{
      console.log(res);
      const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(res);
      if (responseData){
        this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

      }else{
        var newBlob = new Blob([res], { type: 'text/csv' });

        // For other browsers:
        const data = window.URL.createObjectURL(newBlob);
    
        var link = document.createElement('a');
        link.href = data;
        link.download = "SET" + e.rowData.setName + "-QLValidationReport.csv";
        link.click();
    
        // Delay revoking the ObjectURL for a brief moment
        setTimeout(function () {
            window.URL.revokeObjectURL(data);
            link.remove();
        }, 100);
      }
    })
    // }
  }

  downloadQTfileLOader(e){
    this.dFlage = false;
    console.log(e)
    // if(e.rowData.validationreportpath==="" || e.rowData.validationreportpath === null || e.rowData.validationreportpath === undefined){
    //   this.snackbar.open("No File to Download","OK", { duration: 5000 });
    // }else{
    this.spinner.start();
    this.service.downloadValidationReportFile(this.localStorageSettings.getSettings("dnsName"),e.rowData.migrationtraceid+"/"+"QT").subscribe(res=>{
      console.log(res);
      const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(res);
      if (responseData){
        this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

      }else{
        var newBlob = new Blob([res], { type: 'text/csv' });

        // For other browsers:
        const data = window.URL.createObjectURL(newBlob);
    
        var link = document.createElement('a');
        link.href = data;
        link.download = "SET" + e.rowData.setName + "-QTValidationReport.csv";
        console.log("SET_" + e.rowData.setName + "-QTValidationReport.csv");
        link.click();
    
        // Delay revoking the ObjectURL for a brief moment
        setTimeout(function () {
            window.URL.revokeObjectURL(data);
            link.remove();
        }, 100);
      }
    })
    // }
  }

  Validation_report
  downloadValidationReport(path,migrationid,fileName){


    this.downloadQlandQtValidationReports(path,migrationid,fileName)

  }

  downloadQlandQtValidationReports(path,migrationid,fileName){
    this.service.download_test(this.restApi.downloadFileUrl+"/"+"validation/"+"Migration/Validation_report/Validation_"+migrationid+"/"+path+"/"+fileName)
      .subscribe(x => {
        console.log("Migration/Validation_report/"+path+"/"+fileName)
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x]);

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);

        var link = document.createElement('a');
        link.href = data;
        link.download = fileName;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      });

    this.spinner.stop();
  }

  uploadloaderfile(inputValue){
    console.log(inputValue);
    console.log(inputValue.event.target)
    console.log(this.jsuitepropertyValue);
    if(inputValue.rowData.loadstatus === "Failed"){

      let level = inputValue.rowData.level
      let iddbstatuscount = 0;
      console.log(level);

      let ischeckfile=false
      var file: File = inputValue.event.target.files[0];
      var FileS: File = inputValue.event.target.files[0];
      console.log(file.type)
      if (file.type === 'text/csv'){
        ischeckfile=true
      }
      if(!ischeckfile){
            this.snackbar.open(file.name + "is invalid file. Please select Csv file ", "OK", {
          duration: 5000,
        });
      }else{
      //Added condition to check the IDDB/ParentFileMerge status count before uploading the file when load status is failed 
      //Added by Geetha B
      //jraap-6877
      this.service.retrieveIDDBStatusCount(inputValue.rowData.setid,inputValue.rowData.migrationid,this.localStorageSettings.getSettings("dnsName"),level)
                  .subscribe((count: number) => {
                   iddbstatuscount = count;
                   console.log(iddbstatuscount);

      
      if(Number(iddbstatuscount)>0){
        this.snackbar.open("The IDDB/ParentFileMerge is Failed for some objects in level"+ level + ". Please click on Resume Load at Set level to proceed for IDDB/ParentfileMerge update.", "OK", {
        duration: 5000,
       });
      }else{

        console.log(file.size / 1000)
        var size = file.size / 1000
        //commented checking size of file should be less than 3MB because if filesize is more than 3MB then unable to start resume Load
        // if (size <= 25072) {
          var fileName = FileS.name;
            //Modified by Geetha B, 14-08-2023
            //Sending the file data as a Multipart file in a form data
            let objectNametemp = inputValue.rowData.objectname
            let id = inputValue.rowData.id;
            this.updatedsourceFile.uploadfileName = inputValue.rowData.fileName
            this.updatedsourceFile.migrationId = inputValue.rowData.migrationid
            this.updatedsourceFile.setId = inputValue.rowData.setid
            let localPath = this.localStorageSettings.getSettings("vaultDnsname")+"/Load_"+inputValue.rowData.migrationid+"/TransformFiles/SET"+inputValue.rowData.setid;
            //added condition to check the load action of migration trace to set the path for deleted files only when migration trace load action and set load action are delete
            //Added by Geetha B, 05/02/2026
            //jraap-6668
            let migrationLoadAction = "create"
            this.service.retrieveLoadActionOfMigrationTrace(inputValue.rowData.migrationtraceid)
                        .subscribe((migrationTraceLoadAction: string) => {
                             migrationLoadAction = migrationTraceLoadAction;
                             console.log(migrationLoadAction);
                             
            
            if(migrationLoadAction==='delete' && inputValue.rowData.loadAction==='delete'){
              console.log("inside if condition for delete load action")
              localPath=this.localStorageSettings.getSettings("vaultDnsname")+"/Load_"+inputValue.rowData.migrationid+"/TransformFiles/SET"+inputValue.rowData.setid+"/Deleted"
            }
            let sourcefiletemp = {
              fileName:fileName,
              fileData:"",
              path:"C:/TransformAndLoad/"+localPath,
              action:id,
              objectName:objectNametemp,
              transformFileName: this.updatedsourceFile.uploadfileName,
              migrationId: this.updatedsourceFile.migrationId,
              setId: this.updatedsourceFile.setId
            }

            const formData = new FormData();
            formData.append('file',file)
            formData.append('data',JSON.stringify(sourcefiletemp))
            console.log(sourcefiletemp)
            this.uploadSourceFileService(formData);
            
            localPath="";
            id="";
            objectNametemp="";
          });
        } 

       });
      }

    }else{
      this.snackbar.open("The load is in "+ inputValue.rowData.loadstatus + " state cannot upload file.", "OK", {
        duration: 5000,
      });
    }
  }


// Added conditions based on objectloadtype
  uploadSourceFileService(formData){
    this.spinner.start();

    console.log(this.jsuitepropertyValue);
    // comparing with lowercase value
    if(this.jsuitepropertyValue == "parallel"){
      this.service.uploadingSourceFileparallel(formData,this.localStorageSettings.getSettings("dnsName")).subscribe(res=>{
        console.log(res);
        if(res.error===true){
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }else{
          this.onGridReadyVaultValidation(this.vaultvalidationAPI);
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }
      })
    }
    else{
      this.service.uploadingSourceFile(formData,this.localStorageSettings.getSettings("dnsName")).subscribe(res=>{
        console.log(res);
        if(res.error===true){
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }else{
          this.onGridReadyVaultValidation(this.vaultvalidationAPI);
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }


      })
    }
  }
  // author Ravi G modified date: 07/07/2022
  //  function calling popup to trigger emr for summary report
  generateSummaryReport(e){
    console.log(e);
    console.log(e.rowData);
    let width = "45%";
    let dialogRef = this.dialog.open(SpliteAndGenerateQtlReportPopupComponent, {
      maxWidth: '100vw',
      height: '55%',
      width: width,
      data: { data:e.rowData,action:1 },
      disableClose: true
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {

      console.log(result);
    });
    // if(confirm("Are you sure you want to generate validation report?")){
    // this.spinner.start();
    //   this.service.generateSummaryReport(e.rowData.migrationId).subscribe(res=>{
    //     console.log(res);
    //     if(res.error===true){
    //       this.snackbar.open(res.data, "OK", { duration: 5000 });
    //       this.spinner.stop();
    //     }else{
    //       this.snackbar.open(res.data, "OK", { duration: 5000 });
    //       this.spinner.stop();
    //       this.retrieveMigrationLog();
    //     }
    //   })
    // }
  }
  // author Ravi G modified date: 07/07/2022
  //  function calling popup to trigger emr for Split report
  generateSplitReport(e){
    console.log(e.rowData);
    let width = "45%";
    let dialogRef = this.dialog.open(SpliteAndGenerateQtlReportPopupComponent, {
      maxWidth: '100vw',
      height: '55%',
      width: width,
      data: { data:e.rowData ,action:2},
      disableClose: true
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {

      console.log(result);

    });

  }

  selectService(e) {
    let obj = {
      'extraction': 0,
      'transform': 0,
      'loader': 0,
      'loadtoftp': 0,
      'validation':0,
      'buttonName': 'Save',
      'runid': e.rowData.migrationId,
      'status': e.rowData.state,
      'migrationType' :  e.rowData.migrationType,
      'parentRunid':e.rowData.parentmigrationid,
      'mappingfileversion':e.rowData.mappingfileversion
    };
  
    this.spinner.start();
  

  
    this.service.retriveRunningServices(e.rowData.migrationId).subscribe(res => {
      console.log(res);
      try{

      
      if (res.error === true) {
        this.spinner.stop();
        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      } else {
        if (res != null && res != undefined) {
          console.log(res);
          obj.extraction = res.extraction;
          obj.loader = res.loader;
          obj.loadtoftp = res.loadtoftp;
          obj.transform = res.transform;
          obj.validation=res.validation;
          console.log(obj);
        }
      }
    }catch(error){
      
    }
  
      this.spinner.stop();
  
      // Now, open the dialog with obj inside the subscribe block
      let width = "45%";
      let dialogRef = this.dialog.open(RunningJarPopupComponent, {
        maxWidth: '100vw',
        height: '83%',
        width: width,
        data: { edata: obj },
        disableClose: true
      });
  
      // Subscribe to the popup after close
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
      });
    });
  
    console.log(e.rowData); // This will execute before the result of the subscription
  }
  


// Applied condition based on objectloadtype
  resumeLoadfile(e){
    console.log(this.jsuitepropertyValue);
    if(confirm("Initiating Resume Load, Are you sure you want to continue?")){
      let setid = e.rowData.setid
      let objectName = e.rowData.objectname;
      let status = e.rowData.loadstatus;
      this.data={
        "dnsId":this.localStorageSettings.getSettings("dnsName"),
        "userId":this.localStorageSettings.getSettings("UserId"),
        "dnsName":this.localStorageSettings.getSettings("vaultDnsname")
      }
      // this.migrationType="ETL";
      if(status === "Failed"){
        if(this.jsuitepropertyValue != "parallel"){
          this.spinner.start();
          this.service.resumeLoadToVault(this.data.dnsName,this.data.dnsId,setid,this.migrationType,objectName).subscribe(res=>{
            console.log(res);
            this.spinner.stop();
            this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
            setid="";
          })
        }else{
          this.snackbar.open("Sequential resume load cannot be performed.", "OK", { duration: 5000 });
        }
      }else{
        this.snackbar.open("The load is in "+ e.rowData.loadstatus + " state cannot perform reload.", "OK", { duration: 5000 });
      }
    }
  }


// parallel resume load function starts
  resumeparallelLoadfile(e){
    console.log(this.jsuitepropertyValue);
    if(confirm("Initiating Resume Load, Are you sure you want to continue?")){
      let setid = e.rowData.setid
      let migrationTraceId = e.rowData.migrationtraceid;
      let status = e.rowData.state;
      console.log(migrationTraceId);
      this.data={
        "dnsId":this.localStorageSettings.getSettings("dnsName"),
        "userId":this.localStorageSettings.getSettings("UserId"),
        "dnsName":this.localStorageSettings.getSettings("vaultDnsname")
      }
      // this.migrationType="ETL";
      if(status === "Failed"){
        if(this.jsuitepropertyValue == "parallel"){
          this.spinner.start();
          this.service.resumeLoadparallel(migrationTraceId).subscribe(res=>{
            console.log(res);
            this.spinner.stop();
            this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
            setid="";
          })
        }else{
          this.snackbar.open("Parallel resume load cannot be performed.", "OK", { duration: 5000 });
        }
      }else{
        this.snackbar.open("The load is in "+ e.rowData.state + " state cannot perform reload.", "OK", { duration: 5000 });
      }
    }
  }
// parallel resume load function ends


  sourceFile
  zipdownloadSourceFile(e){
    console.log(e.rowData.sourcefilepath)
    this.sourceFile = e.rowData.sourcefilepath
    if(e.rowData.sourcefilepath==="" || e.rowData.sourcefilepath === null || e.rowData.sourcefilepath === undefined){
      this.snackbar.open("No File to Download","OK", { duration: 5000 });
    }else{
      this.spinner.start();
      this.service.download_zip(this.sourceFile)
        .subscribe(x => {
          console.log(x)
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([x],{type:'application/zip'});

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)
          var link = document.createElement('a');
          link.href = data;
          console.log(e.rowData.fileName)
          link.download = "Transformdata"+e.rowData.setName+".zip";
          console.log("ento")
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);
        });
      this.spinner.stop();
    }

  }

  // download generated summary report
  downloadgeneratedSummaryReport(e){
    console.log("Clicked");
    console.log(e);
    console.log(this.restApi.zipanddownloadfilesUrl+"/"+this.localStorageSettings.getSettings("AuthUsername")+"/"+e.rowData.migrationId+"/SummaryReport")
    console.log(this.restrictDownloadSummaryFlag);
    if(this.restrictDownloadSummaryFlag){
      this.spinner.start();
      this.restrictDownloadSummaryFlag=false;
    this.snackbar.open("Download is underway. Please do not click again the download until it completes the download.", "OK", {duration: 10000});

    this.service.download_zip(this.restApi.zipanddownloadfilesUrl+"/"+this.localStorageSettings.getSettings("AuthUsername")+"/"+e.rowData.migrationId+"/SummaryReport")
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x],{type:'application/zip'});

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        console.log(data)
        var link = document.createElement('a');
        link.href = data;
        console.log(e.rowData.fileName)
        link.download = "SummaryReports_"+e.rowData.migrationId+".zip";
        console.log("ento")
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
        this.snackbar.open("Download Completed", "OK", {duration: 5000});
        this.restrictDownloadSummaryFlag=true;

      });
    this.spinner.stop();
  }else{
    console.log("restrict to download when download is inprogress")
    console.log(this.restrictDownloadSummaryFlag);
    this.snackbar.open("Download is underway. Please do not click again the download until it completes the download.", "OK", {duration: 10000});
  }

  }


  downloadAggregationSummaryReport(e){
    if(e.rowData!= undefined){
      console.log(e.rowData)
      this.spinner.start();
      this.service.downloadSummaryeportFile(this.localStorageSettings.getSettings("vaultDnsname"),"Migration/Validation_report/Validation_"+e.rowData.migrationId+"/aggregateSummary/resultFile/aggregation-SummaryReport.csv").subscribe(res=>{
        console.log(res);
        if(res.error===true){
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }else{
          this.downloadSummaryReport(e.rowData.migrationId,"aggregateSummary","resultFile","aggregation-SummaryReport.csv")
          //this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }
      })
    }

  }
  downloadgeneratedSplitReport(e){
    this.service.download_zip(this.restApi.zipanddownloadfilesUrl+"/"+this.localStorageSettings.getSettings("AuthUsername")+"/"+e.rowData.migrationId+"/SplitReport")
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x],{type:'application/zip'});

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        console.log(data)
        var link = document.createElement('a');
        link.href = data;
        console.log(e.rowData.fileName)
        link.download = "SplitReports_"+e.rowData.migrationId+".zip";
        console.log("ento")
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      });
  }
  downloadTransformSummaryReport(e){
    console.log(e)
    if(e.rowData!= undefined){
      console.log(e.rowData)
      this.spinner.start();
      this.service.downloadSummaryeportFile(this.localStorageSettings.getSettings("vaultDnsname"),"Migration/Validation_report/Validation_"+e.rowData.migrationId+"/transformationSummary/transformationResultFile/Transformation-SummaryReport.csv").subscribe(res=>{
        console.log(res);
        if(res.error===true){
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }else{
          this.downloadSummaryReport(e.rowData.migrationId,"transformationSummary","transformationResultFile","Transformation-SummaryReport.csv")
          // this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }
      })
    }
  }

  downloadSummaryReport(migrationid,summaryType,resultfile,filename){
    console.log("clicked");
    this.service.download_test(this.restApi.downloadFileUrl+"/"+"validation/"+"Migration/Validation_report/Validation_"+migrationid+"/"+summaryType+"/"+resultfile+"/"+filename)
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x]);

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);

        var link = document.createElement('a');
        link.href = data;
        link.download = filename;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      });

    this.spinner.stop();
  }
  onRightClick(event) {
    event.preventDefault();
    this.selectedRowDataFromGrid = event
  }


  onCellDoubleClicked(event: any) {
    //show menu if status is in inprogress use can  Abort or Inprogres migration
    //  if status is in Abort use can  Complete or Inprogres migration
    // if status is in Complete use can only Inprogres migration
    console.log(event);
    this.selectedRowDataFromGrid = event
    this.status = event.data.state
    this.migrationId = event.data.migrationId
    console.log(status);


    this.matMenuTrigger.menuData = {item: "abc"}
    // we record the mouse position in our object
    this.menuTopLeftPosition.x = event.event.clientX;
    this.menuTopLeftPosition.y = event.event.clientY;
    this.matMenuTrigger.openMenu();
    if (
      event.data.dataextractiontype.toLowerCase() === 'full data'|| 
      event.data.dataextractiontype.toLowerCase() === 'full data load'
      &&
      event.data.migrationType.toLowerCase() === 'data virtualization'
    ) {
      this.showScheduler = true;
    }
    else if(event.data.dataextractiontype.toLowerCase()=='partial data' && event.data.migrationType.toLowerCase() === 'data migration'&& event.data.state.toLowerCase()=='complete') {
      this.showScheduler = true;
    }
    else {
      this.showScheduler = false;
    }
    
    
  }

  migrationSatus(status: any) {

    this.service.abortmigration(this.localStorageSettings.getSettings("dnsName"), "ETL",status,this.migrationId).subscribe(res=>{
      console.log(res);
      if(res.error===true){
        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        this.spinner.stop();
      }else{
   
        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        this.spinner.stop();
        this.retrieveMigrationLog();
        this.retriveMappingFile()
        this.refreshRun();
        console.log(this.migrationTrace)
       

      }
    })
  }
  /**
   * @author Ravi G
   * @Date 02-09-2022
   * @Desc show detail of attachment load detail
   */
  docAttachedClicked(event) {
    try{
    // activating the Radio buttons
    this.isDisabledForObjectGrid=true;

    console.log(event)
    this.docAttachedClickedEvent = event;
    this.parentSetId = event.data.setid;
    this.migrationTraceId = event.data.migrationtraceid;

    // Initialize all ObjectGrid Properties
    this.currentActivityInMigrationGrid=event.data.activity
    this.currentSetInMigrationGrid=event.data.setid
    this.currentActivityInObjectGrid=event.data.activity;
    this.currentMigrationIdInMigrationGrid=event.data.migrationid;
    this.currentMigrationTraceIdInMigrationGrid=event.data.migrationtraceid

    
    if(event.data.activity =="AttachmentLoadToFTP") {
          // activating the Attachment load grid
          this.extractionInstrictionTrace =false;
          this.loadInstructionTrace=false;
          this.attachmentLoadInstructionTrace=true;
          //check the radio button for attchment load grid
          this.objectRadioValue="loadObjects"
      if (event.data.state == "Completed") {
        this.retrieveAttachmentsBasedOnMigrationTraceId()

      }
      else {
        this.extractionInstrictionTrace =false;
          this.loadInstructionTrace=false;
          this.attachmentLoadInstructionTrace=false;
        this.currentMigrationTraceIdInMigrationGrid=undefined
        this.gridAPIValidation.setGridOption('rowData', [])
        this.snackbar.open(this.constant.loadFtpisNotCompleted, "OK", {duration: 5000});
      }
    }
          /*  
             * @modified by Shantanu Ghate
             * @Date 28-03-2026
             * added the condition for AuditTrailExtraction
          */
    else if(event.data.activity=="AttachmentExtraction" || event.data.activity=="AuditTrailExtraction"){
        // activating the attachment extraction grid
        this.extractionInstrictionTrace=true;
        this.loadInstructionTrace=false;
        this.attachmentLoadInstructionTrace=false;
        //check the radio button for attchment load grid
        this.objectRadioValue="extractionObjects"

        this.spinner.start()
        this.onGridReadyThirdGridDataForExtractionAndTransformation(this.vaultvalidationAPI)
        this.spinner.stop()
    }
    else{
      this.snackbar.open(this.constant.noDetailForAttachmentExtraction, "OK", {duration: 5000});

    }
  }catch(e){
    console.log(e)
  }
    this.spinner.stop()
  
  }

  /**
   * @author Ravi G
   * @Date 03-09-2022
   * @Desc updating load to vault status
   */
  loadToVault(e){
    console.log(e)
    if(e.rowData.loaderFileCreation == "In Progress"){

      this.snackbar.open(this.constant.loaderFileGenerationStatus, "OK", {duration: 5000});

    }
    else if(e.rowData.loaderFileCreation == "Failed"){
      this.snackbar.open(this.constant.loaderFileStatusFailed, "OK", {duration: 5000});

    }
    else{
      this.spinner.start();
      const obj ={
        "attachmentLoadId":e.rowData.attachmentLoadDetailsId,
        "LoadToVault":""
      };
      this.service.updateLoadReadyStatus(obj).subscribe(res=>{{
        console.log(res)
        if(res['error']===true){
          this.spinner.stop()
          this.snackbar.open(res['statusMessage'], "OK", {duration: 5000});

        }else{
          this.spinner.stop()
          this.refreshObjects();
          this.snackbar.open(res['data'], "OK", {duration: 5000});

        }


      }
      })
    }


  }

  onGridReadyDocAttachment(param) {

    this.gridAPIValidation =param.api


  }
  downloadDocAttachmentFilePath(e){
    console.log("Clicked");
    console.log(e);
    this.spinner.start();
    const obj ={
      "attachmentLoadId":e.rowData.attachmentLoadDetailsId,
      "download":"LoaderFile"
    };
    this.service.updateLoadReadyStatus(obj).subscribe((x:any) => {
      console.log(x)

      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should

      var newBlob = new Blob([x]);


      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(newBlob);
      //   return;
      // }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      console.log(data)
      var link = document.createElement('a');
      link.href = data;

      link.download = e.rowData.loaderFileName;

      console.log("ento")
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
    this.spinner.stop();
  }
  docAttachmentsuccessDoc
  docAttachmentdownloadSuccess(e){
    console.log(e.rowData)
    this.docAttachmentsuccessDoc = e.rowData.successCount
    if (this.docAttachmentsuccessDoc===undefined || this.docAttachmentsuccessDoc=== "" || this.docAttachmentsuccessDoc ===null){
      this.docAttachmentsuccessDoc =0

    }
    if(this.docAttachmentsuccessDoc <=0 ){
      this.snackbar.open(this.constants.successLogNotAvailable, "OK", {duration: 5000});
    }else{
      this.spinner.start();
      console.log("Clicked");
      console.log(e);
      this.spinner.start();
      const obj ={
        "attachmentLoadId":e.rowData.attachmentLoadDetailsId,
        "download":"SuccessLog"
      };
      this.service.updateLoadReadyStatus(obj).subscribe((x:any) => {

        this.spinner.stop();
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x]);

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        console.log(data)
        var link = document.createElement('a');
        link.href = data;
        console.log(e.rowData.fileName)
        link.download = e.rowData.loaderFileName.split(".")[0]+"_success_log.csv";
        console.log("ento")
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      });
      this.spinner.stop();
    }
  }


  docAttachmentfailureDoc
  docAttachmentdownloadFailure(e){
    console.log(e.rowData)
    this.docAttachmentfailureDoc = e.rowData.failureCount
    if(this.docAttachmentfailureDoc===undefined || this.docAttachmentfailureDoc=== "" || this.docAttachmentfailureDoc ===null){
      this.docAttachmentfailureDoc=0;
    }

    if(this.docAttachmentfailureDoc <=0){
      this.snackbar.open(this.constants.failureLogNotAvailable, "OK", {duration: 5000});
    }else{
      this.spinner.start();
      console.log("Clicked");
      console.log(e);
      this.spinner.start();
      const obj ={
        "attachmentLoadId":e.rowData.attachmentLoadDetailsId,
        "download":"FailureLog"
      };

      this.service.updateLoadReadyStatus(obj).subscribe((x:any) => {
        this.spinner.stop();
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x]);

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        console.log(data)
        var link = document.createElement('a');
        link.href = data;
        console.log(e.rowData.fileName)

        link.download = e.rowData.loaderFileName.split(".")[0]+"_failure_log.csv";
        console.log("ento")
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      });
      this.spinner.stop();
    }
  }

  downloadMappingFile(e){
   if(this.gridColumnApi.includes(118)){
    let migrationId =e.rowData.migrationId
    this.service.downloadMappingFile(migrationId).subscribe(x => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should

      console.log(x)
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        if (responseData){
          this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        } else{
          console.log(x)
          var newBlob = new Blob([x]);
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = "DM_Mappingfile_"+migrationId+".xlsx";
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

        }




    })
  }
  else{
    this.snackbar.open(this.constants.Mappingfile, "OK", {duration: 5000});
  }

  }

  /**
   * added By Ravi G
   * 27/09/2022
   * added button in case data for attachment Link To Case
   */
  linkToCases(e){
    console.log(e)
    console.log(e.param.column.colId)
   let migrationId =  e.rowData.migrationid;
   let setId = e.rowData.setid;
   console.log("linkToCases")
    if(confirm("Initiating Link Attachments to Cases, Are you sure you want to continue?")) {
      this.spinner.start();
      this.service.attachmentLinkToCase(setId, migrationId).subscribe(res => {
        console.log(res)
        this.spinner.stop()
        this.snackbar.open(res['statusMessage'], "OK", {duration: 5000});
      })
    }

  }

    /**
   * added By Abhishek
   * 28/12/2022
   * added button in case data for attachment Link To Case
   */
    resumeExtraction(e){
      console.log(e)
      //console.log(e.param.column.colId)
     let migrationId =  e.rowData.migrationid;
     let setId = e.rowData.setid;
     let dnsId=e.rowData.dnsId;
     console.log("linkToCases")
      if(confirm("Initiating target extraction, Are you sure you want to continue?")) {
        this.spinner.start();
        this.service.resumeVaultObjectExtraction(setId, migrationId,dnsId).subscribe(res => {
          console.log(res)
          this.spinner.stop()
          this.snackbar.open(res['statusMessage'], "OK", {duration: 5000});
        })
      }

    }

  /**
   * @Added by Ravi G
   * @Date: 23/11/2022
   * @Desc this popup is to add sets for migration with current runid which is in progress by specifying extractiontype for those sets
   */
  addSets() {
   let dialogRef = this.dialog.open(AddSetsForMigrationPopupComponent, {
      maxWidth: '100%',
     width: '53%',
     height: '69%',
      data: this.mgrid,
      disableClose: true
    });
  }

  reInitiateAttData(e){

    let dialogRef = this.dialog.open(ReInitiatePopupComponent, {
      width: '53%',
      height: '69%',
      data: {reInitateType:'ad',migrationId:e.rowData.migrationid,setId:e.rowData.setid},
      disableClose: true
    });

  }
  /**
   * @Added by Ravi G
   * @Date: 23/11/2022
   * @Desc this popup is to re-initiate migration process for particular set i.e.,
   * if user want to Extract, Transform set once again then if user try to add same set in add sets for migration popup then they will get error,
   * so we provided option to re-initiate same set once again
   */
  reInitiateCaseData(e){
    /**
     * Modified by Ashwin M
     * 05/09/2025
     * code modified to identify current migration ecord based on the data of the selected row and send data to popup component
     */
    let migrationCurrent;
    for (let index = 0; index < this.gridmgrnData.length; index++) {
      const element = this.gridmgrnData[index];
      if (element.migrationId == e.rowData.migrationid){
        migrationCurrent = element
      }
    }
    console.log(migrationCurrent)
    let dialogRef = this.dialog.open(ReInitiatePopupComponent, {
      width: '53%',
      height: '69%',
      data: {reInitateType:'cd',migrationId:e.rowData.migrationid,setId:e.rowData.setid,migrationTraceId:e.rowData.migrationtraceid, migrationCurrent: migrationCurrent},
      disableClose: true
    });

  }

onReMigrateClick() {
  this.reMigratePopupBttn();

}
  /**
   * @Added by Ravi G
   * @Date: 23/11/2022
   * @Desc this popup is to re-migrate sets which means already sets data is loaded to vault then if user wants to update the data which is already loaded then user needs to click on re-migrate button for particular set
   **/
  reMigratePopupBttn(){
    let dialogRef = this.dialog.open(ReInitiatePopupComponent, {
      width: '80%',
      height: '80%',
      data: {reInitateType:'rm',migrationId:this.migrationParentId},
      disableClose: true
    });
    console.log(this.migrationParentId);
  }

  mappingFileValidationPath
  downloadMappingFileValidationReport(e){
    console.log(e.rowData)
    this.mappingFileValidationPath = e.rowData.mappingFileValidationPath
    let migrationId = e.rowData.migrationId
    if(this.mappingFileValidationPath===undefined || this.mappingFileValidationPath=== "" || this.mappingFileValidationPath ===null){
      this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

    }else{
      this.spinner.start();
      let fileName =  this.mappingFileValidationPath.split('/').pop()
      let data = {
        s3Path:this.mappingFileValidationPath,
      };
      this.service.downloadFileFromS3(data).subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should

        console.log(x)
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        if (responseData){
          this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        } else{
          console.log(x)
          var newBlob = new Blob([x]);
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

        }




      })

      this.spinner.stop();
    }

  }
  validateMappingFile(e){
    if(this.gridColumnApi.includes(118)){
    if (confirm('Are you sure you want to validate mapping file?')) {
      console.log("validateMappingFile")
      console.log(e.rowData.migrationId)
      let migrationId = e.rowData.migrationId;
      this.spinner.start();
      this.service.uploadValidateMappingFile(migrationId).subscribe(res => {
        console.log(res);
        this.spinner.stop()
        this.snackbar.open(res['statusMessage'], "OK", {duration: 5000});
      })
    }
   }
   else{
    this.snackbar.open(this.constants.Mappingfile, "OK", {duration: 5000});
   }

  }

//   emrLogsDownload1(e){

//     console.log(e)
//     // if(e.rowData.validationreportpath==="" || e.rowData.validationreportpath === null || e.rowData.validationreportpath === undefined){
//     //   this.snackbar.open("No File to Download","OK", { duration: 5000 });
//     // }else{
//     this.spinner.start();
//    var userName=this.localStorageSettings.getSettings("AuthUsername")
//    var setId=e.rowData.migrationId
//    var report
// var obj={
//   "userName":userName,
//   "setId":e.rowData.setid,
//   "migrationId":e.rowData.migrationid,
//   "reportType":"EMRLogs"
// }
//     this.service.downloadEMRLogsFile(obj).subscribe(res=>{

//       console.log(res);
//       if(res.error===true){
//         this.spinner.stop();
//         this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
//       }else{

//         this.downloadValidationReport(e.rowData.setName,e.rowData.migrationid,e.rowData.setName+"-QTValidationReport.csv")

//         this.spinner.stop();
//         this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
//       }
//     })
//     // }
//   }

    // download generated summary report
    emrLogsDownload(e){
      this.dFlage = false;
      console.log("Clicked");
      console.log(e);
   
      this.spinner.start();
      var userName=this.localStorageSettings.getSettings("AuthUsername")
      var setId=e.rowData.migrationId
      var report
   var obj={
     "userName":userName,
     "setId":e.rowData.setid,
     "migrationId":e.rowData.migrationid,
     "reportType":"EMRLogs"
   }
      this.spinner.start();
      this.service.downloadEMRLogsFile(obj).subscribe(x=>{
  
   //     .subscribe(x => {
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([x],{type:'application/zip'});

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)
          var link = document.createElement('a');
          link.href = data;
          console.log(e.rowData.fileName)
          link.download = "SET"+e.rowData.setid+"EMRLogs"+".zip";
          console.log("ento")
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);
        });
      this.spinner.stop();
    }

  deleteCaseFromVault(e){
    var migrationTraceId = e.rowData.migrationtraceid
    console.log(migrationTraceId);
    console.log("delete Case From vault")
    var deleteText = prompt(this.constants.deletionConformationMessage)
    console.log(deleteText);
    if(deleteText === 'Delete' || deleteText === 'delete') {
      this.spinner.start();
      this.service.updateDeleteStatusForSet(migrationTraceId).subscribe(res => {
        console.log(res)
        this.refresh()
        this.spinner.stop()
        this.snackbar.open(res['statusMessage'], "OK", {duration: 5000});
      })
      /*
      * Modified by Ashwin M
      * 08/12/2022
      * code modified to alert user for wrong input
      */
    }else{
      this.snackbar.open("Enter valid input to start deletion", "OK", {duration: 5000});
    }


  }
  /* @added by Ravi G
        @date 9-12-2022
        @desc show popup for create and show vault global objects
 */
  vaultGlobalObject(e){
    console.log(e.rowData);
    let width = "55%";
    let dialogRef = this.dialog.open(VaultGlobalObjectsComponent, {
      maxWidth: '100vw',
      height: "70%",
      width: width,
      data: { data:e.rowData},
      disableClose: true
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {

      console.log(result);

    });
  }
  reInitiateGlobalData(e){
    let dialogRef = this.dialog.open(ReInitiatePopupComponent, {
      width: '53%',
      height: '69%',
      data: {reInitateType:'gm',migrationId:e.rowData.migrationid,setId:e.rowData.setid},
      disableClose: true
    });
    
  }

onGridReadyThirdGridDataForExtractionAndTransformation(params) {
    try {
      this.vaultvalidationAPI = params;
      this.gridDataValidation = [];
      this.gridAPIValidation = params.api
      this.gridColumnAPI = params.api
      this.gridAPIValidation.setGridOption('rowData', [])
      console.log(this.migrationTraceId);
      this.spinner.start();
      if (this.migrationTraceId != undefined) {
        this.service.retrieveExtractionTransformationInstructionRecords(this.currentMigrationTraceIdInMigrationGrid).subscribe((val) => {
          console.log(val)
          this.gridDataValidation = val;
          this.tempextdata = [];
          this.extractionInstructionData = [];
          if (this.gridDataValidation.length === 0) {
            this.gridAPIValidation.setGridOption('rowData', []);
            this.spinner.stop();
            if(this.dFlage)
              {
              this.snackbar.open(this.constant.instructionsNotAvaialble, "OK", { duration: 5000 });
              }
              this.dFlage = true;
          } else {
            for (const element of this.gridDataValidation) {
              if (element.migrationid == this.migrationParentId) {
                element.setName = element.setid;
                element.migrationid = "Run_" + element.migrationid;
                this.tempextdata = element;
                this.extractionInstructionData.push(this.tempextdata);
              }
            }
            console.log(this.gridDataValidation)
            this.gridAPIValidation.setGridOption('rowData', this.extractionInstructionData)
            this.spinner.stop();
          }
        }

        );
      }
    }
    catch (e) {
      this.spinner.stop()
      console.log(e)
    }

}
  cellClickedGlobalExtractedData(e) {
    // activating the radio buttons in the object grid
    this.isDisabledForObjectGrid=true;
    console.log(e);
    console.log(e.data.setid);
    this.setSelect = true;
    this.parentSetId = e.data.setid;
    this.migrationTraceId = e.data.migrationtraceid
    console.log(this.parentSetId)
    console.log(this.migrationTraceId);

     // for third grid variables
     this.currentSetInMigrationGrid = e.data.setid
     this.currentActivityInMigrationGrid = e.data.activity
     this.currentMigrationIdInMigrationGrid = e.data.migrationid
     this.currentMigrationTraceIdInMigrationGrid = e.data.migrationtraceid
     this.currentActivityInObjectGrid=e.data.activity
     this.migrationTraceId=e.data.migrationtraceid
     this.currentActivityInObjectGrid=e.data.activity;

    if (!e.colDef.cellRenderer) {
      if (e.data.activity == "GlobalExtraction") {
        // Only check radio button for extraction
        this.objectRadioValue="extractionObjects";


        this.extractionInstrictionTrace = true
        this.loadInstructionTrace = false
        this.attachmentLoadInstructionTrace = false
        this.spinner.start()
        this.onGridReadyThirdGridDataForExtractionAndTransformation(this.vaultvalidationAPI)
        this.spinner.stop()
      }
    }
    this.spinner.stop()
  }
  /**
   * @author Sai Naveen Somaraju
   * @date 28/07/2023
   * This method will be called from the Html page when ever we change the radio button in third grid(curretn object status grid).
   * when we change the radio button the value will be modified according to the value we will perform operations
   * @param e 
   */
  objectData(e) {
    this.spinner.start()
    try {
      if (e.value == "extractionObjects") {
        if(this.migrationTrace){
        this.currentActivityInObjectGrid = "Extraction";
        //making the extractioninstruction grid available for extraction instructions
        
        }
        else if(this.transformTrace){
          // this.currentActivityInObjectGrid = "AttachmentExtraction";
           /* 
             * @modified by Shantanu Ghate
             * @Date 28-03-2026
             * This process the AuditTrailExtraction same as AttachmentExtraction
          */
          if(this.currentActivityInMigrationGrid === "AuditTrailExtraction"){
            this.currentActivityInObjectGrid = "AuditTrailExtraction";
          } else {
            this.currentActivityInObjectGrid = "AttachmentExtraction";
          }
        }
        else if(this.globaltrace){
          this.currentActivityInObjectGrid = "GlobalExtraction";
        }
        
        this.extractionInstrictionTrace = true
        this.loadInstructionTrace = false
        this.attachmentLoadInstructionTrace = false
        this.retrieveInstructionsBasedOnActivity(this.vaultvalidationAPI)
      }
      else if (e.value == "transformObjects") {
        this.currentActivityInObjectGrid = "Transform"
        //making the extractioninstruction(used for transformation also) grid available for extraction instructions
        this.extractionInstrictionTrace = true
        this.loadInstructionTrace = false
        this.attachmentLoadInstructionTrace = false
        this.retrieveInstructionsBasedOnActivity(this.vaultvalidationAPI)

      }
      else if (e.value == "loadObjects") {
        if(this.migrationTrace){
        this.currentActivityInObjectGrid = "Load"
        //making the loadInstructionTrace grid available for Load instructions
        this.extractionInstrictionTrace = false
        this.loadInstructionTrace = true
        this.attachmentLoadInstructionTrace = false
        // this.retrieveInstructionsBasedOnActivity(this.vaultvalidationAPI)
        }
        else if(this.transformTrace){
          this.currentActivityInObjectGrid = "AttachmentLoadToFTP";
          //making the attachmentLoadInstructionTrace grid available for Load instructions
          this.extractionInstrictionTrace = false
          this.loadInstructionTrace = false
          this.attachmentLoadInstructionTrace = true
          this.retrieveAttachmentsBasedOnMigrationTraceId()


        }
      }
      else {
        this.currentActivityInObjectGrid = "Validation";

      }
    } catch (e) {
      console.log(e)
    }
    this.spinner.stop();
  }
/**
 * @author SaiNaveen Somaraju
 * @Date : 31/07/2023
 * @Note This method will retrieve the instructions for extraction,transfromation and load with out migrationtraceid
 * @param params 
 */
  retrieveInstructionsBasedOnActivity(params) {
    try {
      console.log(params)
      console.log("test")
      if (this.currentActivityInObjectGrid && this.currentMigrationIdInMigrationGrid) {
        console.log("test2")
        if (this.currentActivityInObjectGrid == "Load" || this.currentActivityInObjectGrid == "Validation") {
          console.log("test3")

          console.log("Calling instructionbyactivity method for Load without migrationtraceid api call")
          this.vaultvalidationAPI = params;
          this.gridAPIValidation = params.api;
          this.gridDataValidation = [];
          this.gridAPIValidation.setGridOption('rowData', [])
          this.spinner.start();

          this.service.retrieveInstructionByActivity(this.localStorageSettings.getSettings("dnsName"), this.currentMigrationIdInMigrationGrid, this.currentSetInMigrationGrid, this.currentActivityInObjectGrid).subscribe((val) => {
            console.log(val)
            this.gridDataValidation = val;
            if (this.gridDataValidation.length === 0) {
              this.currentMigrationTraceIdInMigrationGrid = null;
              this.gridAPIValidation.setGridOption('rowData', [])
              this.spinner.stop();
              if(this.dFlage)
                {
                this.snackbar.open(this.constant.instructionsNotAvaialble, "OK", { duration: 5000 });
                }
                this.dFlage = true;
            } else {
              this.temploaddataValidation = [];
              this.vaultValidationData = [];
              let parentDeleted;
              this.currentMigrationTraceIdInMigrationGrid = this.gridDataValidation[0].migrationtraceid
              for (const element of this.gridDataValidation) {
                console.log(element.migrationtraceid === this.migrationTraceId)
                if (element.migrationtraceid === this.migrationTraceId) {
                  if (element.state === 'Deleted') {
                    parentDeleted = true;
                  }
                }
              }
              for (const element of this.gridDataValidation) {
                console.log(element.loadAction === 'delete')
                //added one more condition to check the set laodaction not only instruction load action
                if ((element.loadAction === 'delete' || parentDeleted)&&this.loadActionForSelecetdSet==='delete') {
                  element['isLoadActionDelete'] = true;
                } else {
                  element['isLoadActionDelete'] = false;
                }
                element.setName = element.setid;
                element.runInstance = "Run_" + element.migrationid
                this.temploaddataValidation = element;
                this.vaultValidationData.push(this.temploaddataValidation);
                // }
              }
              console.log(this.vaultValidationData)
              this.gridAPIValidation.setGridOption('rowData', this.vaultValidationData)
              this.spinner.stop();
            }
          });

        }
        else {
          console.log("Calling instructionbyactivity method for Extraction/Tranformation without migrationtraceid api call")
          this.vaultvalidationAPI = params;
          this.gridDataValidation = [];
          this.gridAPIValidation = params.api
          this.gridColumnAPI = params.api
          this.gridAPIValidation.setGridOption('rowData', [])
          console.log(this.migrationTraceId);
          this.spinner.start();

          this.service.retrieveInstructionByActivity(this.localStorageSettings.getSettings("dnsName"), this.currentMigrationIdInMigrationGrid, this.currentSetInMigrationGrid, this.currentActivityInObjectGrid).subscribe((val) => {
            console.log(val)
            this.gridDataValidation = val;
            this.tempextdata = [];
            this.extractionInstructionData = [];
            if (this.gridDataValidation.length === 0) {
              this.currentMigrationTraceIdInMigrationGrid = null;
              this.gridAPIValidation.setGridOption('rowData', []);
              this.spinner.stop();
              if(this.dFlage)
                {
                this.snackbar.open(this.constant.instructionsNotAvaialble, "OK", { duration: 5000 });
                }
                this.dFlage = true;
            } else {
              this.currentMigrationTraceIdInMigrationGrid = this.gridDataValidation[0].migrationtraceid
              for (const element of this.gridDataValidation) {
                if (element.migrationid == this.migrationParentId) {
                  element.setName = element.setid;
                  element.migrationid = "Run_" + element.migrationid;
                  this.tempextdata = element;
                  this.extractionInstructionData.push(this.tempextdata);
                }
              }
              console.log(this.gridDataValidation)
              this.gridAPIValidation.setGridOption('rowData', this.extractionInstructionData)
              this.spinner.stop();
            }
          }

          );

        }
      }
    }
    catch (e) {
      console.log(e)
    }
  }

  /**
   * @author SaiNaveen Somaraju
   * @Date : 31/07/2023
   * @note This method will retrieve the Attachment Load Instruction details based on migrationtraceid
   */
  retrieveAttachmentsBasedOnMigrationTraceId() {
    this.spinner.start()
    console.log("Calling the instructions for AttachmentLoadToFTP based on migrationtraceid")
    if (this.currentMigrationTraceIdInMigrationGrid != undefined) {
      this.service.retrievingAttachmentLoadDetails(this.currentMigrationTraceIdInMigrationGrid).subscribe(res => {
        
        let tempnullchkdata=res
        console.log(res);
        if (res.error === true) {
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          this.gridAPIValidation.setGridOption('rowData', []);
          this.spinner.stop();
        } 
        else if(tempnullchkdata.length===0){
          this.gridAPIValidation.setGridOption('rowData', []);
          this.spinner.stop();
        }else {
          this.currentMigrationTraceIdInMigrationGrid=res[0].migrationTraceId;
          var tempdata = [];
          this.tempAttachmentgridData = [];
          for (const element of res) {
            tempdata = element;
            this.tempAttachmentgridData.push(tempdata);
          }
          console.log(this.tempAttachmentgridData)
          this.gridAPIValidation.setGridOption('rowData', this.tempAttachmentgridData);
          this.spinner.stop()
        }
      })
    }
    else {
      this.spinner.stop();
      console.log("Unable to fetch the migrationtraceid for AttachmentLoad to FTP")
      this.snackbar.open("something went wrong.", "Ok", { duration: 5000 });
    }
  }
  /**
   * @author SaiNaveen Somaraju
   * @Date : 31/07/2023
   * @note This method will retrieve the Attachment Load Instruction details based on migrationid,dnsid and setid
   */
  retrieveAttachmentsBasedOnMigrationIdAndSetId() {
    this.spinner.start()
    this.service.retrieveInstructionByActivity(this.localStorageSettings.getSettings("dnsName"), this.currentMigrationIdInMigrationGrid, this.currentSetInMigrationGrid, this.currentActivityInObjectGrid).subscribe(res => {
      console.log(res);
     let tempnullchkdata=res
      if (res.error === true) {
        this.gridAPIValidation.setGridOption('rowData', []);
        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        this.spinner.stop();
      }
      else if(tempnullchkdata.length===0){
        this.gridAPIValidation.setGridOption('rowData', []);
        this.spinner.stop();
      }
      else {
        var tempdata = [];
        this.tempAttachmentgridData = [];
        this.currentMigrationTraceIdInMigrationGrid = res[0].migrationTraceId
        for (const element of res) {
          tempdata = element;
          this.tempAttachmentgridData.push(tempdata);
        }
        console.log(this.tempAttachmentgridData)
        this.gridAPIValidation.setGridOption('rowData', this.tempAttachmentgridData);
        this.spinner.stop()
      }
    })
  }
   /*
  Added by ABhishek T
  13-09-2023
  Added to select custom headers in grid
*/
openSaveForm(event,gridname) {
  let dataToSend=[];
  if (gridname.toLowerCase() === "migration") {
    dataToSend = this.columDifsForMigrationTemp.map(columnDef => ({ headername: columnDef.headerName }));
  } else if (gridname.toLowerCase() === "casedata") {
    dataToSend = this.columnDefsExtractTemp.map(columnDef => ({ headername: columnDef.headerName }));
    if(this.selectedGrid=='old'){
      let hideHeaders = ["Start Date and Time", "End Date and Time"];
      let visibleHeaders = dataToSend.filter(column =>
        !hideHeaders.some(header => header.toLowerCase().trim() === column.headername.toLowerCase().trim())
      );
      dataToSend = visibleHeaders;
    }else{
      let hideHeaders = ["Extraction Start", "Extraction End","Transformation Start","Transformation End","Load Start","Load End"];
      let visibleHeaders = dataToSend.filter(column =>
        !hideHeaders.some(header => header.toLowerCase().trim() === column.headername.toLowerCase().trim())
      );
      dataToSend = visibleHeaders;
    }
  }
  
  event.stopPropagation();
  let width = "60%";
  let dialogRef = this.dialog.open(HeadersPopupDialogComponent, {
    maxWidth: "90vw",
    height: "80%",
    width: width,
    data:   dataToSend,
    disableClose: true,
  });
  

  dialogRef.afterClosed().subscribe((result) => {
    console.log(result);
    if(result!=undefined){}
    if (result!=undefined&&typeof result === 'boolean') {
      if(gridname.toLowerCase() === "migration"){
      this.columnDefsFormigration=[
        {
          headerName: "Migration Id",
          headerTooltip: "Migration Id",
          tooltipValueGetter: params => "Migration Id : " + params.value,
          field: "migrationId",
          filter: "agTextColumnFilter",
          width: 120
        },
        // added column in run history grid for comments
        {
          headerName: 'Description',
          headerTooltip: 'Description',
          tooltipValueGetter: (params) => 'Description : ' + params.value,
          field: 'comment',
          filter: 'agTextColumnFilter',
          width: 200
        },
        {
          headerName: 'Start Date and Time',
          headerTooltip: 'Start Date and Time',
          tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value,
          field: 'startdt',
          filter: 'agTextColumnFilter',
          width: 180
        },
        {
          headerName: 'End Date and Time',
          headerTooltip: 'End Date and Time',
          tooltipValueGetter: (params) => 'End Date and Time : ' + params.value,
          field: 'enddt',
          filter: 'agTextColumnFilter',
          width: 180
        },
        {
          headerName: 'Status',
          headerTooltip: 'Status',
          tooltipValueGetter: (params) => 'Status : ' + params.value,
          field: 'state',
          filter: 'agTextColumnFilter',
          sort: "desc",
          width: 120
        },
        {

          headerName: 'Services Assigned', filter: false, cellRenderer: 'generateBttn',
          headerTooltip: 'Services Assigned',
          tooltipValueGetter: (params) => 'Services Assigned',
          cellRendererParams: {
            generateReport: this.selectService.bind(this),
            //delete: this.deleteIcon.bind(this),
          }, width: 120
        },
        {
          headerName: 'Migration Type',
          headerTooltip: 'Migration Type',
          tooltipValueGetter: (params) => 'Migration Type : ' + params.value,
          field: 'migrationType',
          filter: 'agTextColumnFilter',
          width: 200
          },
        {
          headerName: 'Validate Configurations', filter: false, cellRenderer: 'generateBttn',
          headerTooltip:'Validate Configurtions',
          tooltipValueGetter: (params) => 'Validate Configurtions',
          cellRendererParams: {
            generateReport: this.validateConfigurations.bind(this),
            
          }, width: 120
        },
      ];
      this.onGridReadymigration(this.temprunHistory);
    }
    else if (gridname.toLowerCase() === "casedata") {
      
      this.columnDefsExtract = [
        {
          headerName: 'Set Name',
          headerTooltip: 'Set Name',
          tooltipValueGetter: (params) => 'Set Name : ' + params.value,
          field: 'setName',
          filter: 'agTextColumnFilter',
          sort: 'asc',
          cellStyle: {textAlign: "right"},
          width: 120
        },
        
        {
          headerName: 'Current Process',
          headerTooltip: 'Current Process',
          tooltipValueGetter: (params) => 'Current Process : ' + params.value,
          field: 'activity',
          filter: 'agTextColumnFilter',
          width: 120
        },
        {
          headerName: 'Status',
          headerTooltip: 'Status',
          tooltipValueGetter: (params) => 'Status : ' + params.value,
          field: 'state',
          filter: 'agTextColumnFilter',
          width: 120
        },
       
        {
          headerName: 'Remarks',
          headerTooltip: 'Remarks',
          tooltipValueGetter: (params) => 'Remarks : ' + params.value,
          field: 'remarks',
          filter: 'agTextColumnFilter',
          width: 120
        },
      
        {
          headerName: 'Log/Output Files', filter: false, cellRenderer: 'migrationDownloadRenderer',
          headerTooltip: 'Download Logs',
          cellRendererParams: {
            extractDownload: this.downloadmappingfileExtract.bind(this),
            transformDownload: this.downloadmappingfileExtract.bind(this),
            loadDownload: this.downloadmappingfileExtract.bind(this),
            vaultExtractedDownload: this.downloadmappingfileExtract.bind(this),
            //delete: this.deleteIcon.bind(this),
          }, width: 220
        },
        {
          headerName: 'Validation Report',
          headerTooltip: 'Validation Report',
          filter: false, cellRenderer: 'ValidationReportDownloadRender',
          cellRendererParams: {
            qlDownload: this.downloadQLfileLOader.bind(this),
            qtDownload:this.downloadQTfileLOader.bind(this),
            emrLogsDownload:this.emrLogsDownload.bind(this)
            //delete: this.deleteIcon.bind(this),
          }, width: 190
        },
        {
          headerName: 'Action',
          headerTooltip: 'Action',
          filter: false, cellRenderer: 'resumeLoadRenderer',
          cellRendererParams: {
            resumeLoadButton: this.resumeparallelLoadfile.bind(this),
            //delete: this.deleteIcon.bind(this),
          }, width: 120
        },
        {
          headerName: 'Re-Initiate', filter: false, cellRenderer: 'reInitiateRenderer',
          headerTooltip: 'Re-Initiate',
          tooltipValueGetter: (params) => 'Re-Initiate ',
          cellRendererParams: {
            reInitiate: this.reInitiateCaseData.bind(this),
            //delete: this.deleteIcon.bind(this),
          }, width: 120
        },
        
        // Header for machineid
        {
          headerName: 'Machine Id',
          headerTooltip: 'Machine Id',
          tooltipValueGetter: (params) => 'Machine Id : ' + params.value,
          field: 'machineid',
          filter: 'agTextColumnFilter',
          width: 150
        },
        
      ]
      this.onGridReadyCaseData(this.tempextractparams);
    }
    }
    else if(result!=undefined && result.length>0){
      if(gridname.toLowerCase() === "migration"){
      this.columnDefsFormigration=null;
      this.columnDefsFormigration=[
        {
          headerName: "Migration Id",
          headerTooltip: "Migration Id",
          tooltipValueGetter: params => "Migration Id : " + params.value,
          field: "migrationId",
          filter: "agTextColumnFilter",
          width: 120
        },
        // added column in run history grid for comments
        {
          headerName: 'Description',
          headerTooltip: 'Description',
          tooltipValueGetter: (params) => 'Description : ' + params.value,
          field: 'comment',
          filter: 'agTextColumnFilter',
          width: 200
        },
        {
          headerName: 'Start Date and Time',
          headerTooltip: 'Start Date and Time',
          tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value,
          field: 'startdt',
          filter: 'agTextColumnFilter',
          width: 180
        },
        {
          headerName: 'End Date and Time',
          headerTooltip: 'End Date and Time',
          tooltipValueGetter: (params) => 'End Date and Time : ' + params.value,
          field: 'enddt',
          filter: 'agTextColumnFilter',
          width: 180
        },
        {
          headerName: 'Status',
          headerTooltip: 'Status',
          tooltipValueGetter: (params) => 'Status : ' + params.value,
          field: 'state',
          filter: 'agTextColumnFilter',
          sort: "desc",
          width: 120
        },
        {
          headerName: 'Services Assigned', filter: false, cellRenderer: 'generateBttn',
          headerTooltip: 'Services Assigned',
          tooltipValueGetter: (params) => 'Services Assigned',
          cellRendererParams: {
            generateReport: this.selectService.bind(this),
            //delete: this.deleteIcon.bind(this),
          }, width: 120
        },
         /**
     * @modifiedby Raghottam Joshi
     * @Date 05/03/2024
     * @Note Made Migration Type as a Default Column
     */
      {
      headerName: 'Migration Type',
      headerTooltip: 'Migration Type',
      tooltipValueGetter: (params) => 'Migration Type : ' + params.value,
      field: 'migrationType',
      filter: 'agTextColumnFilter',
      width: 200
      },
  /*
     * @modifiedby Sujeet Kumar
     * @Date 19/09/2025
     * @Note Made Remarks as a Default Column
     * @RCA Remarks column was getting removed when user added new columns 
     *      from popup because it was not part of the default column list.
     *      Fix ensures Remarks will always remain visible in the grid.
     */
       {
            headerName: 'Remarks',
            headerTooltip: 'Remarks',
            tooltipValueGetter: (params) => 'Remarks : ' + params.value,
            field: 'remarks',
            filter: 'agTextColumnFilter',
            width: 120
          },
       
      ];
      for (let i = 0; i < result.length; i++) {
        for (let j = 0; j < this.columDifsForMigrationTemp.length; j++) {
          if (result[i].headername === this.columDifsForMigrationTemp[j].headerName) {
            // Check if the element doesn't already exist in columnDefsFormigration
            if (!this.columnDefsFormigration.some(item => item.headerName === result[i].headername)) {
              this.columnDefsFormigration.push(this.columDifsForMigrationTemp[j]);
            }
          }
        }
      }
      
    console.log( this.columnDefsFormigration);

    this.onGridReadymigration(this.temprunHistory);
    }
    else if (gridname.toLowerCase() === "casedata") {
      
      this.columnDefsExtract = [
        {
          headerName: 'Set Name',
          headerTooltip: 'Set Name',
          tooltipValueGetter: (params) => 'Set Name : ' + params.value,
          field: 'setName',
          filter: 'agTextColumnFilter',
          sort: 'asc',
          cellStyle: {textAlign: "right"},
          width: 120
        },
        
        {
          headerName: 'Current Process',
          headerTooltip: 'Current Process',
          tooltipValueGetter: (params) => 'Current Process : ' + params.value,
          field: 'activity',
          filter: 'agTextColumnFilter',
          width: 120
        },
        {
          headerName: 'Status',
          headerTooltip: 'Status',
          tooltipValueGetter: (params) => 'Status : ' + params.value,
          field: 'state',
          filter: 'agTextColumnFilter',
          width: 120
        },
       
        {
          headerName: 'Remarks',
          headerTooltip: 'Remarks',
          tooltipValueGetter: (params) => 'Remarks : ' + params.value,
          field: 'remarks',
          filter: 'agTextColumnFilter',
          width: 120
        },
      
        {
          headerName: 'Log/Output Files', filter: false, cellRenderer: 'migrationDownloadRenderer',
          headerTooltip: 'Download Logs',
          cellRendererParams: {
            extractDownload: this.downloadmappingfileExtract.bind(this),
            transformDownload: this.downloadmappingfileExtract.bind(this),
            loadDownload: this.downloadmappingfileExtract.bind(this),
            vaultExtractedDownload: this.downloadmappingfileExtract.bind(this),
            //delete: this.deleteIcon.bind(this),
          }, width: 220
        },
        {
          headerName: 'Validation Report',
          headerTooltip: 'Validation Report',
          filter: false, cellRenderer: 'ValidationReportDownloadRender',
          cellRendererParams: {
            qlDownload: this.downloadQLfileLOader.bind(this),
            qtDownload:this.downloadQTfileLOader.bind(this),
            emrLogsDownload:this.emrLogsDownload.bind(this)
            //delete: this.deleteIcon.bind(this),
          }, width: 190
        },
        {
          headerName: 'Action',
          headerTooltip: 'Action',
          filter: false, cellRenderer: 'resumeLoadRenderer',
          cellRendererParams: {
            resumeLoadButton: this.resumeparallelLoadfile.bind(this),
            //delete: this.deleteIcon.bind(this),
          }, width: 120
        },

        /*
     * @modifiedby Raghottam Joshi
     * @Date 13/03/2024
     * @Note Made Re-Initiate as a Default Column
     */
         {
          headerName: 'Re-Initiate', filter: false, cellRenderer: 'reInitiateRenderer',
          headerTooltip: 'Re-Initiate',
          tooltipValueGetter: (params) => 'Re-Initiate ',
          cellRendererParams: {
            reInitiate: this.reInitiateCaseData.bind(this),
            //delete: this.deleteIcon.bind(this),
          }, width: 120
        },
        
        // Header for machineid
        {
          headerName: 'Machine Id',
          headerTooltip: 'Machine Id',
          tooltipValueGetter: (params) => 'Machine Id : ' + params.value,
          field: 'machineid',
          filter: 'agTextColumnFilter',
          width: 150
        },
       
      ]
      for (let i = 0; i < result.length; i++) {
        for (let j = 0; j < this.columnDefsExtractTemp.length; j++) {
          if (result[i].headername === this.columnDefsExtractTemp[j].headerName) {
            // Check if the element doesn't already exist in columnDefsExtract
            if (!this.columnDefsExtract.some(item => item.headerName === result[i].headername)) {
              this.columnDefsExtract.push(this.columnDefsExtractTemp[j]);
            }
          }
        }
      }

      this.onGridReadyCaseData(this.tempextractparams);
    }
  
  }}
  );
 
}

/**
 * @param e 
 * @author Sai Naveen Somaraju
 * @description It will populate the popup for validation configurations
 */
validateConfigurations(e){
  if(e.rowData.migrationType=='Data Migration'){
    if(e.rowData.state=='In Progress'){
       this.dialog.open(ValidateconfigurationPopupComponent, {
        width: '85%',
        height: '76%',
        data: {migrationId:e.rowData.migrationId,dnsId:e.rowData.dnsid,state:e.rowData.state,screenType:'default'},
        disableClose: true
      });
    }
    else{
      this.snackbar.open("Selected Migration is not in 'In Progress'.","Ok",{duration:5000})
    }
   
  }
    else{
      this.snackbar.open("This is only applicable for 'Data Migration' runs","Ok",{duration:5000})
    }
  }


  deleteObjects() {
    let width = "65%";
    let dialogRef = this.dialog.open(DeleteObjctsPopupComponent, {
      maxWidth: '100vw',
      height: "60%",
      width: width,
      data:{},
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      window.location.reload();
    });
  }
}
